<template>
  <div class="wrap">
    <myHead></myHead>
    <div class="wrap_body">
      <div class="center">
        <div class="ucenter_main">
          <ucMenu num="3"></ucMenu>
          <div class="right_con">
            <div class="goods_main">
              <p class="fb">订单列表</p>
              <div class="select_wrap">
                <el-form :inline="true" size="small">
                  <el-form-item label="下单平台" v-show="false">
                    <el-select class="w290" v-model="searchData.platform_type" placeholder="请选择" clearable filterable >
                      <el-option v-for="item in platformTypeList" :key="item.val" :label="item.text" :value="item.val">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="店铺分组">
                    <el-select class="w290" v-model="searchData.group_ids" placeholder="全部分组" clearable multiple
                               collapse-tags filterable @change="setChange">
                      <el-option v-for="item in groupList" :key="item.id" :label="item.name"
                                 :value="item.id" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="店铺名">
                    <el-select class="w290" v-model="searchData.shop_id" placeholder="请选择" clearable>
                      <el-option v-for="item in arrShop" :key="item.key" :label="item.key" :value="item.val">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="商品信息">
                    <el-input class="w290" v-model="searchData.product_name" placeholder="请输入商品标题/商品ID" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="店铺订单号">
                    <el-input class="w290" v-model="searchData.dd_order_id" placeholder="请输入店铺订单号" clearable> </el-input>
                  </el-form-item>
                  <el-form-item label="采购订单号">
                    <el-input class="w290" v-model="searchData.pdd_order_id" placeholder="请输入采购订单号" clearable> </el-input>
                  </el-form-item>
                  <el-form-item label="采购备注">
                    <el-input class="w290" v-model="searchData.pdd_purchase_msg" placeholder="请输入采购备注" clearable> </el-input>
                  </el-form-item>
                  <el-form-item label="采购账号">
                    <el-input class="w290" v-model="searchData.pdd_account" placeholder="请输入采购账号" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="采购快递单号">
                    <el-input class="w290" v-model="searchData.pdd_express_no" placeholder="请输入采购快递单号" clearable> </el-input>
                  </el-form-item>
                  <el-form-item label="买家退货单号">
                    <el-input class="w290" v-model="searchData.return_logistics_code" placeholder="请输入买家退货单号" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="平台退货单号">
                    <el-input class="w290" v-model="searchData.pdd_return_logistics_code" placeholder="请输入平台退货单号" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="问题订单">
                    <el-select class="w290" v-model="searchData.problem_types" multiple collapse-tags placeholder="请选择" clearable>
                      <el-option v-for="item in arrProblemType" :key="item.val" :label="item.text" :value="item.val">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="关联状态">
                    <el-select class="w290" v-model="searchData.link_status" placeholder="请选择" clearable>
                      <el-option v-for="item in arrLinkStatus" :key="item.val" :label="item.text" :value="item.val">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="抖店备注">
                    <el-input class="w290" v-model="searchData.seller_words" placeholder="请输入抖店备注" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="旗帜颜色">
                    <el-select class="w290" v-model="searchData.seller_remark_stars" multiple collapse-tags placeholder="请选择" clearable>
                      <el-option v-for="item in arrStar" :key="item.val" :label="item.text" :value="item.val">
                        <span style="float: left">{{ item.text }}</span>
                        <span style="float: right;"><i :class="item.icon" :style="[{color:item.color}]"></i></span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="留言备注">
                    <el-select class="w290" v-model="searchData.remark_filters" multiple collapse-tags placeholder="请选择" clearable>
                      <el-option v-for="item in arrRemarkFilter" :key="item.val" :label="item.text" :value="item.val">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="实收金额">
                    <div class="search-amount-range">
                      <el-input v-model="searchData.receive_amount_min" placeholder="最小" clearable class="amount-input"></el-input>
                      <span class="amount-sep">-</span>
                      <el-input v-model="searchData.receive_amount_max" placeholder="最大" clearable class="amount-input"></el-input>
                    </div>
                  </el-form-item>
                  <el-form-item label="省份">
                    <el-select class="w290" v-model="searchData.province_ids" multiple collapse-tags placeholder="请选择" clearable filterable>
                      <el-option v-for="item in arrProvince" :key="item.val" :label="item.text" :value="item.val">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="多子订单">
                    <el-select class="w290" v-model="searchData.multi_child_order" multiple collapse-tags placeholder="请选择" clearable>
                      <el-option v-for="item in arrChildOrderNumFilter" :key="'multi_' + item.val" :label="item.text" :value="item.val">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="合并采购">
                    <el-select class="w290" v-model="searchData.merge_purchase" placeholder="请选择" clearable>
                      <el-option v-for="item in arrYesNoLayout" :key="'merge_' + item.val" :label="item.text" :value="item.val">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="买家下单">
                    <el-date-picker class="w320"
                                    v-model="searchData.create_time"
                                    type="datetimerange"
                                    align="right"
                                    unlink-panels
                                    range-separator="至"
                                    start-placeholder="买家下单开始日期"
                                    end-placeholder="买家下单结束日期"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    @onPick="datePick"
                                    :picker-options="pickerOptions"
                                    :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="采购下单">
                    <el-date-picker class="w320"
                                    v-model="searchData.pdd_order_time"
                                    type="datetimerange"
                                    align="right"
                                    unlink-panels
                                    range-separator="至"
                                    start-placeholder="采购下单开始日期"
                                    end-placeholder="采购下单结束日期"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    @onPick="datePick"
                                    :picker-options="pickerOptions"
                                    :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="货损订单">
                    <el-select class="w290" v-model="searchData.damaged_filter" placeholder="请选择" clearable>
                      <el-option v-for="item in arrDamagedFilter" :key="item.val" :label="item.text" :value="item.val">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="货损时间">
                    <el-date-picker class="w320"
                                    v-model="searchData.damaged_time"
                                    type="datetimerange"
                                    align="right"
                                    unlink-panels
                                    range-separator="至"
                                    start-placeholder="货损开始时间"
                                    end-placeholder="货损结束时间"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    @onPick="datePick"
                                    :picker-options="pickerOptions"
                                    :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="">
                    <el-button plain size="small" @click="doSearch()">查询</el-button>
                    <el-button plain size="small" @click="resetSearch()">重置</el-button></el-form-item>
                </el-form>
              </div>
              <div class="tabs_wrap">
                <p class="tab" :class="{ active: searchData.pdd_order_status === '' }" @click="changeStatus('')">全部订单</p>
                <p class="tab" :class="searchData.pdd_order_status==s.val?'active':''" v-for="(s,i) in arrPddStatus" :key="i" @click="changeStatus(s.val)">{{ s.text }}
                  <el-badge class="mark" :value="s.num" v-if="s.num > 0"/>
                </p>
                <!-- <p class="tab">已签收未确认<i class="iconfont icon-clock"></i></p>
								<p class="tab">已确认未评价<i class="iconfont icon-clock"></i></p> -->
              </div>
              <div class="totals_btn">
                <p class="totals">共{{ page_data.total }}条</p>
                <el-button plain size="small" @click="bindBatDelete()">批量删除</el-button>
                <!-- <el-button plain size="small" @click="bindBatPurchase()">批量采购</el-button> -->
                <el-button plain size="small" v-if="searchData.pdd_order_status == 100 || searchData.pdd_order_status == 102" @click="bindBatAlibabaPurchase()">批量厂家直采</el-button>
                <el-button plain size="small" @click="bindBatCancelPurchase()">批量取消</el-button>
                <el-button plain size="small" @click="orderExport()">批量导出</el-button>
                <!-- <el-button plain size="small" @click="sendGiftOrder()" v-if="searchData.pdd_order_status < 130">发礼品单</el-button> -->
                <!-- <el-button plain size="small" @click="openAutoGift()">自动发礼品</el-button> -->
                <el-button plain size="small" @click="setNotDeal()" v-if="searchData.pdd_order_status === 140">批量完结</el-button>
                <el-button plain size="small" :loading="sync_order_queue_count>0" @click="openSyncDdOrderQueue()">{{sync_order_queue_count>0?'正在同步':'同步抖店订单'}}</el-button>
                <el-button plain size="small" v-if="searchData.pdd_order_status == 100||searchData.pdd_order_status == 101||searchData.pdd_order_status == 102" @click="openBatchAlibabaConnect">批量关联</el-button>
                <el-button plain size="small" @click="bindBatchMarkProblem()">标记问题</el-button>
                <el-button plain size="small" @click="bindBatchMarkException()">批量标记异常</el-button>
                <p class="damaged_total_summary" v-if="isDamagedSearch">
                  货损总额：<span>¥{{ damaged_total_amount }}</span>
                </p>
              </div>
              <div class="list_title">
                <label class="checkall">
                  <el-checkbox v-model="checkAll" @change="bindCheckAll">全选</el-checkbox>
                </label>
                <p class="t1">货品信息<i class="iconfont el-icon-view" style="font-size: 14px;margin-left: 5px;cursor: pointer;" @click="showOrderInfo()"></i></p>
                <p class="t2">售价/数量</p>
                <p class="t3">订单状态</p>
                <p class="t4">金额</p>
                <p class="t5">退货信息</p>
                <p class="t6">
                  采购单详情
                  <el-tooltip effect="dark" content="按每个1688采购单展示商品、SKU、运单及状态；修改关联请在右侧操作列" placement="top">
                    <i class="el-icon-info purchase_col_tip"></i>
                  </el-tooltip>
                </p>
                <!--                <p class="t6">采购状态</p>-->
                <p class="t7">操作</p>
              </div>
              <ul class="order_list">
                <el-checkbox-group v-model="checkList" @change="bindCheckList">
                  <li v-for="(item,index) in list" :key="index">
                    <div class="info_top">
                      <div class="order_nums">
                        <div class="check_box">
                          <el-checkbox :label="item.id" :key="item.id" :checked="item.checked"></el-checkbox>
                        </div>
                        <p class="num" v-if="item.dd_shop">
                          <span class="shop_name">{{  isHideOrderInfo ? '************' : item.dd_shop.shop_name }}</span>
                          抖店单号：{{ item.dd_order_id }}<i class="iconfont icon-fuzhi" @click="bindCopy(item.dd_order_id)"></i>
                        </p>
                        <p class="num" v-if="item?.pdd_order?.order_id">
                          {{ item.pdd_order?.buy_mode == 3 ? '巴巴' : '多多'}}单号：
                          <span
                              :class="{ 'order-id-link': isAlibabaPurchaseOrder(item.pdd_order) }"
                              @click.stop="openAlibabaOrderDetail(item.pdd_order)"
                          >{{ item.pdd_order.order_id }}</span>
                          <a
                              v-if="hasMultipleAlibabaOrders(item)"
                              href="javascript:;"
                              class="baba-order-more"
                              @click.stop="openAlibabaOrderIdsDialog(item)"
                          >更多</a>
                          <i
                              v-else
                              class="iconfont icon-fuzhi"
                              @click="bindCopy(item.pdd_order.order_id)"
                          ></i>
                        </p>
                        <p class="num" v-if="!item.dd_shop"><span class="shop_name">店铺已删除</span>：{{ item.dd_order_id }}<i class="iconfont icon-fuzhi" @click="bindCopy(item.dd_order_id)"></i></p>

                        <p class="num" v-if="item.shop_type==0">平台单号：{{ item.order_no }}<i class="iconfont icon-fuzhi" @click="bindCopy(item.order_no)"></i></p>
                        <p class="date">下单时间：{{ item.create_time }}</p>
                        <p
                            class="as-countdown"
                            v-if="getAftersaleCountdownText(item)"
                            @click.stop="goOrderAftersaleDetail(item)"
                        >
                          请在 <span class="as-countdown-num">{{ getAftersaleCountdownText(item) }}</span> 内处理，超时未处理将自动同意退款
                        </p>
                        <!--											<i v-if="item.dd_order_id!='0'" class="btn-remark el-icon-s-flag" @click="showRemark(item.order_id)" :style="{'color':item.seller_remark_starts_info.color}"></i>-->
                      </div>
                      <div class="order_top_actions">
                        <el-button
                            class="abnormal_btn"
                            plain
                            size="mini"
                            :type="item.is_abnormal > 0 ? 'warning' : ''"
                            @click="bindMarkProblem(item)"
                        >标记问题</el-button>
                        <el-button
                            class="abnormal_btn"
                            plain
                            size="mini"
                            :type="item.is_exception == 1 ? 'danger' : ''"
                            @click="bindMarkException(item)"
                        >{{ item.is_exception == 1 ? '取消异常' : '标记异常' }}</el-button>
                        <div class="order_flag">
                          <!-- <el-tooltip class="item" effect="dark" content="点击查看原订单" placement="top" v-if="item.pid > 0">
													<p class="flag_box" @click="showOriginalOrder(item.pdd_order.dd_order_id)">换货单</p>
												</el-tooltip>
												<el-tooltip class="item" effect="dark" content="点击查看换货单" placement="top" v-if="item.has_child_order > 0">
													<p class="flag_box old" @click="showOriginalOrder(item.pdd_order.dd_order_id,2)">换货原单</p>
												</el-tooltip> -->
                          <el-tooltip class="item" effect="dark" content="点击查看原订单" placement="top"
                                      v-if="item.is_exchange==1 && item.dd_order_id.includes('B')">
                            <p class="flag_box"
                               @click="showOriginalOrder(item.dd_order_id)">换货单</p>
                          </el-tooltip>
                          <el-tooltip class="item" effect="dark" content="点击查看换货单" placement="top"
                                      v-if="item.is_exchange == 1 && !item.dd_order_id.includes('B')">
                            <p class="flag_box old"
                               @click="showOriginalOrder(item.dd_order_id, 2)">换货原单
                            </p>
                          </el-tooltip>
                          <template v-if="item.damaged_labels && item.damaged_labels.length">
                            <el-tooltip
                                v-for="(label, dIdx) in item.damaged_labels"
                                :key="'dmg-' + dIdx"
                                placement="top"
                                :disabled="label !== '合采货损' || !item.damaged_detail"
                            >
                              <div slot="content" v-if="label === '合采货损' && item.damaged_detail">
                                <p v-for="(row, rIdx) in item.damaged_detail.items" :key="'row-' + rIdx">
                                  {{ row.spec }}，单价{{ row.unit_price }}，小计{{ row.subtotal }}
                                </p>
                                <p>运费：{{ item.damaged_detail.shipping_fee }}</p>
                                <p>合计：{{ item.damaged_detail.purchase_total }}（抖店{{ item.damaged_detail.dd_total }}）</p>
                              </div>
                              <p class="flag_box damaged">
                                {{ label }}<span
                                  v-if="dIdx === item.damaged_labels.length - 1 && item.damaged_amount > 0"
                                  class="damaged_amount_inline"
                              > ¥{{ item.damaged_amount }}</span>
                              </p>
                            </el-tooltip>
                          </template>
                        </div>
                      </div>
                    </div>


                    <div class="order_info">
                      <div class="order_product">
                        <div class="product_item">
                          <div class="goods_info">
                            <div class="img_box"><img class="coverimg" :src="item.product_pic" @click="openImg(item)"/></div>
                            <div class="con_box">
                              <p class="title">{{  isHideOrderInfo ? '************' : item.product_name }}</p>
                              <p class="t1">{{ item.spec_value }}</p>
                              <p class="t1" v-if="item.is_exchange == 1">换货规格：{{ item.exchange_product_spec_str }}</p>
                              <p class="t2">
                                <span>商品编码：{{ item.pdd_sku_id ?? item.pdd_code }}</span>
                                <span @click="editProductCode(item,index)" style="cursor: pointer;text-align: justify;">
								                                    <i class="el-icon-edit" style="margin-left: 5px;"></i>
								                                </span>
                                <span @click="bindCopy('https://mobile.yangkeduo.com/goods.html?goods_id='+(item.pdd_sku_id ?? item.pdd_code))" style="cursor: pointer;text-align: justify;">
								                                    <i class="iconfont icon-fuzhi" style="margin-left: 5px;font-size: 14px;"></i>
								                                </span>
                              </p>
                              <p class="t1">
                                <span>商品ID：{{ item.goods_id ?? item.goods_id }}</span>
                              </p>
                              <p class="t1">
                                <span>规格ID：{{ item.sku_id ?? item.sku_id }} <span class="query_permanent_link" @click="querySkuPermanentRelative(item)">查询是否永久关联</span></span>
                              </p>
                              <p class="t2" v-if="item.supplier">供应商：{{ item.supplier.nickname }}</p>
                              <p class="t2" v-if="item.deliver_ageing">发货时效：{{ item.deliver_ageing }}</p>
                              <p class="t2" v-if="item.supplier_remark">
                                <el-tooltip class="item" effect="dark" :content="item.supplier_remark" placement="top">
                                  <span class="sp_remark">供应商备注：{{ item.supplier_remark }}</span>
                                </el-tooltip>
                              </p>
                              <p class="stock_msg" v-if="item.abb_purchase_amount > 0 && searchData.pdd_order_status == 100">
                                <span>直采价：{{ item.abb_purchase_amount ?? '0.00' }}</span>
                              </p>
                              <p class="stock_msg" v-if="item.ready_stock_amount > 0 && searchData.pdd_order_status == 100">
                                <span>直发价：{{ item.ready_stock_amount ?? '0.00' }}</span>
                              </p>
                              <p class="stock_msg" v-if="item.pdd_order?.order_id">
                                <span>采购价：{{ getGoodsPurchaseCost(item).pay }}</span>
                                <span>代发费：{{ getGoodsPurchaseCost(item).freight }}</span>
                              </p>
                              <p class="stock_msg" v-if="item.pdd_order?.order_id">
                                <span v-if="false">采购费：{{ item.pdd_order.purchase_fee ?? '0.00' }}</span>
                                <span>毛利润：{{ item.profit }}</span>
                              </p>
                              <p class="stock_msg" v-if="item.stock_msg">{{ item.stock_msg }}</p>
                              <!-- <p class="guanlian" :class="item.pdd_product_sku_id==0&&'red'" v-if="(item.pdd_status==0 || item.pdd_status==100) && (item.order_status!=1 && item.order_status!=4)"><span @click="callCG(item)">{{ item.pdd_product_sku_id != 0 ? "修改关联" : "关联商品" }}</span></p> -->
                            </div>
                          </div>
                          <div class="goods_num">
                            <p class="t1">{{ item.pay_amount }}</p>
                            <p class="t2">x{{ item.item_num }}</p>
                          </div>
                          <div class="goods_sales">
                            <p class="t1">抖店状态:{{ item.order_status_text }}</p>
                            <p class="t1">采购状态:{{ getPurchaseStatusText(item) }}</p>
                            <p class="t1" v-if="item.combo_type == 2">
                              <span class="combo_flag">组合商品</span>
                              <span v-if="item.alibaba_items_summary">（{{ item.alibaba_items_summary.success || 0 }}/{{ item.alibaba_items_summary.total || 0 }} 成功）</span>
                            </p>
                            <p class="t1 red" v-if="item.pdd_status == 102 && item.abb_purchase_msg">{{ item.abb_purchase_msg }}</p>
                            <p class="t1" v-if="item.pdd_status== 120 && item.order_alibaba_order?.step_date > 0">发货失败原因：{{item.order_alibaba_order?item.order_alibaba_order.step_remark:'未知错误'}}</p>
                            <p v-if="item.pay_time > 0" class="t2">
                              <el-tooltip class="item" effect="dark" content="买家付款时间" placement="top">
                                <i class="el-icon-time" style="color:grey;"></i>
                              </el-tooltip>
                              {{ item.pay_time_str ?? '暂无' }}
                            </p>
                            <p v-if="item.pdd_order?.order_time > 0" class="t2">
                              <el-tooltip class="item" effect="dark" content="采购下单时间" placement="top">
                                <i class="el-icon-time" style="color:#fa6767;"></i>
                              </el-tooltip>
                              {{ item.pdd_order?.order_time_str ?? '暂无' }}
                            </p>
                            <p v-if="item.order_alibaba_order?.show_send_time_row" class="t2">
                              <el-tooltip class="item" effect="dark" :content="item.order_alibaba_order?.send_time > 0 ? '采购发货时间' : '点击获取1688发货时间'" placement="top">
                                <i class="el-icon-time" style="color:#e6a23c;"></i>
                              </el-tooltip>

                              <span v-if="item.order_alibaba_order?.send_time > 0"> {{ item.order_alibaba_order?.send_time_str ?? '暂无' }}</span>
                              <a
                                  v-else
                                  href="javascript:;"
                                  class="details"
                                  @click="fetchAlibabaSendTime(item)"
                              >获取采购发货时间</a>
                            </p>
                            <p v-if="item.pdd_order?.sync_time > 0" class="t2">
                              <el-tooltip class="item" effect="dark" content="采购同步时间" placement="top">
                                <i class="el-icon-sort" style="color:grey;"></i>
                              </el-tooltip>
                              {{ item.pdd_order?.sync_time_str ?? '暂无' }}
                            </p>
                            <p v-if="item.order_status!=4" style="display: flex;align-items: center;cursor: pointer;">买家信息：<i class="iconfont el-icon-view" @click="showAddressInfo(item.order_id)"></i></p>
                          </div>
                        </div>
                        <!--												<p class="red" style="margin-left: 14px;">总利润：{{item.total_partner_profit}}</p>-->
                      </div>
                      <div class="goods_pay">
                        <div class="t1">实付：￥{{ item.pay_amount }}</div>
                        <div class="t2">运费险：{{ item.post_insurance_amount }}</div>
                        <div class="t2">平台优惠：{{ item.promotion_platform_amount }}</div>
                        <div class="t2">精选联盟：{{ item.c_biz == 1 ? '是' : '否' }}</div>
                        <!-- <p class="t3">采购价</p>
												<p class="t4">￥{{item.order_amount}}</p> -->
                      </div>


                      <div class="goods_buyer">
                        <div v-if="item.order_after_sales">
                          <div class="t1">退款金额：<span>{{ item.order_after_sales.refund_amount }}</span></div>
                          <div class="t2" v-if="item.pdd_order?.refund_status > 0">采购退款状态：<span>{{ item.pdd_order?.refund_status_text }}</span></div>
                          <div class="t2" v-if="item.pdd_order?.return_logistics_code">平台退货运费：<span>{{ item.pdd_order?.refund_freight }}</span></div>
                          <div class="t2" style="text-align: justify;color: red;" v-if="item.lack_type">{{ item.lack_type_text }}{{ item.lack_day > 0 ? (item.lack_day + '天') : '' }}</div>
                          <div class="t2" style="text-align: justify;color: red;" v-if="item.order_after_sales">{{ item.order_after_sales.text_part.aftersale_status_text }}</div>
                          <div class="t2" style="text-align: justify;color: red;" v-if="item.order_after_sales">{{ item.order_after_sales.text_part.aftersale_type_text }}</div>
                        </div>
                        <div v-else>
                          <div class="text-gray">暂无退货信息</div>
                        </div>
                      </div>
                      <div class="goods_purchase_detail">
                        <!-- 按每个 1688 采购单展示；FE-B 布局调整；2026-08-17 -->
                        <template v-if="getPurchaseGroups(item).length">
                          <div
                              v-for="(group, gidx) in getPurchaseGroups(item)"
                              :key="'pg-'+item.id+'-'+group.key+'-'+gidx"
                              class="purchase_order_block"
                              :class="{ 'is-fail': group.has_fail }"
                          >
                            <div class="purchase_order_head">
                              <span class="po_label">采购单{{ getPurchaseGroups(item).length > 1 ? (gidx + 1) : '' }}</span>
                              <span
                                  v-if="group.alibaba_order_id"
                                  class="po_order_id order-id-link"
                                  @click.stop="openAlibabaOrderById(group.alibaba_order_id)"
                              >{{ group.alibaba_order_id }}</span>
                              <span v-else class="po_order_id muted">未下单</span>
                              <!-- <span class="frozen_tag" v-if="group.is_frozen">已冻结</span> -->
                              <span class="line_status_tag" v-if="group.status_text" :class="'st-'+group.status_code"><span class="label">采购状态:</span>{{ group.status_text }}</span>
                            </div>
                            <div class="purchase_supplier" v-if="group.wangwang_account">
                              <span class="label">上家旺旺:</span>
                              <span class="name">{{ group.wangwang_account }}</span>
                              <i
                                  class="el-icon-chat-dot-round purchase_icon"
                                  @click.stop="openAlibabaWangwangChat(group.wangwang_account)"
                              ></i>
                            </div>
                            <!-- 组合/子行：每个采购单下的 SKU -->
                            <template v-if="group.lines && group.lines.length">
                              <div
                                  v-for="(aline, aidx) in group.lines"
                                  :key="'ai-'+item.id+'-'+aline.id+'-'+aidx"
                                  class="purchase_product_card combo_item_card"
                                  :class="{ 'is-fail': aline.line_status == 90 || aline.line_status == 100 }"
                              >
                                <div
                                    class="card_img"
                                    :class="{ 'is-link': aline.offer_id || aline.alibaba_goods_id }"
                                    @click.stop="openAlibabaOfferDetail(aline.offer_id || aline.alibaba_goods_id)"
                                >
                                  <img class="coverimg" :src="aline.product_img || ''" alt="">
                                </div>
                                <div class="card_body">
                                  <p class="card_title_row">
																		<span
                                        class="card_title"
                                        :class="{ 'is-link': aline.offer_id || aline.alibaba_goods_id }"
                                        @click.stop="openAlibabaOfferDetail(aline.offer_id || aline.alibaba_goods_id)"
                                    >{{ aline.product_name || aline.alibaba_goods_id || '-' }}</span>
                                    <!-- <span class="line_status_tag" :class="'st-'+aline.line_status">{{ aline.line_status_text }}</span> -->
                                  </p>
                                  <p class="card_sku">SKU: {{ aline.sku_spec_value || aline.alibaba_sku_id || '-' }} × {{ aline.qty_unit || 1 }}（采 {{ aline.buy_num || 1 }}）</p>
                                  <p class="card_fail_msg" v-if="aline.abb_purchase_msg">{{ aline.abb_purchase_msg }}</p>
                                </div>
                              </div>
                            </template>
                            <!-- 普通单：无子行时用直采关联卡片 -->
                            <div class="purchase_product_card" v-else-if="group.link">
                              <div
                                  class="card_img"
                                  :class="{ 'is-link': group.link.offer_id }"
                                  @click.stop="openAlibabaOfferDetail(group.link.offer_id)"
                              >
                                <img class="coverimg" :src="group.link.product_img || ''" alt="">
                              </div>
                              <div class="card_body">
                                <p
                                    class="card_title"
                                    :class="{ 'is-link': group.link.offer_id }"
                                    @click.stop="openAlibabaOfferDetail(group.link.offer_id)"
                                >{{ group.link.product_name || '-' }}</p>
                                <p class="card_sku">上家SKU: {{ group.link.sku_spec_value || '-' }}</p>
                                <p class="card_min">最低采购件数: {{ group.link.min_order_qty ?? 1 }}</p>
                              </div>
                            </div>
                            <div class="purchase_order_meta">
                              <div
                                  v-if="group.account_text || canCancelPurchaseGroup(item, group)"
                                  class="purchase_account_row"
                              >
                                <span class="account_text" v-if="group.account_text">采购账号：{{ group.account_text }}</span>
                                <span class="account_text" v-else></span>
                                <el-button
                                    v-if="canCancelPurchaseGroup(item, group)"
                                    type="danger"
                                    plain
                                    size="mini"
                                    class="cancel_group_btn"
                                    @click.stop="delPurchaseGroup(item, group)"
                                >取消该组采购</el-button>
                              </div>
                              <p v-if="hasPurchaseGroupAmount(group)">
                                采购金额：{{ formatMoney(group.pdd_pay_amount) }}
                                <span class="po_fee">运费：{{ formatMoney(group.shipping_fee) }}</span>
                                <span class="po_fee">合计：{{ formatMoney(group.total_amount) }}</span>
                              </p>
                              <p v-for="(tn, tidx) in (group.tracking_list || [])" :key="'tn-'+tidx">
                                运单：{{ tn.no }}<span v-if="tn.main">（主）</span>
                              </p>
                              <p v-if="group.express_no && !(group.tracking_list && group.tracking_list.length)">采购快递：{{ group.express_no }}</p>
                            </div>
                            <div class="purchase_footer is_linked">
                              <div
                                  class="return_address_row"
                                  :class="getPurchaseReturnAddressClass(item, group)"
                                  @click="editAlibabaAddress(item, group)"
                              >
                                <div class="return_address_head">
                                  <span class="return_label">退货地址</span>
                                  <span class="return_status_tag">{{ getPurchaseReturnAddressLabel(item, group) }}</span>
                                  <i
                                      :class="Number(item.return_address_readonly) === 1 ? 'el-icon-view return_edit_icon' : 'el-icon-edit return_edit_icon'"
                                  ></i>
                                  <el-tooltip
                                      v-if="getPurchaseReturnAddressState(item, group) <= 0"
                                      effect="dark"
                                      :content="getPurchaseReturnAddressError(item, group) || '未创建'"
                                      placement="top"
                                  >
                                    <i class="el-icon-warning return_warn_icon"></i>
                                  </el-tooltip>
                                </div>
                                <p
                                    v-if="getPurchaseReturnAddressTime(item, group)"
                                    class="return_time"
                                >{{ getPurchaseReturnAddressTime(item, group) }}</p>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <div class="purchase_empty">暂无直采关联</div>
                          <div class="purchase_footer is_linked">
                            <div
                                class="return_address_row"
                                :class="getPurchaseReturnAddressClass(item)"
                                @click="editAlibabaAddress(item)"
                            >
                              <div class="return_address_head">
                                <span class="return_label">退货地址</span>
                                <span class="return_status_tag">{{ getPurchaseReturnAddressLabel(item) }}</span>
                                <i class="el-icon-edit return_edit_icon"></i>
                                <el-tooltip
                                    v-if="item.return_address_state <= 0"
                                    effect="dark"
                                    :content="item.return_address_error || '未创建'"
                                    placement="top"
                                >
                                  <i class="el-icon-warning return_warn_icon"></i>
                                </el-tooltip>
                              </div>
                              <p
                                  v-if="getPurchaseReturnAddressTime(item)"
                                  class="return_time"
                              >{{ getPurchaseReturnAddressTime(item) }}</p>
                            </div>
                          </div>
                        </template>
                      </div>
                      <div class="goods_status">
                        <p v-if="canEditAlibabaDirectLink(item)">
                          <a href="javascript:;" class="details" @click="alibabaCG(item)">{{ isAlibabaDirectLinked(item) ? '修改关联' : '厂家直采关联' }}</a>
                        </p>
                        <!-- <p v-if="!item.pdd_order && !item.delete_time"><a href="javascript:;" class="details" @click="bindPurchase(item)">PDD采购</a></p> -->
                        <p v-if="item.can_manual_dd_deliver == 1"><a href="javascript:;" class="details" @click="bindManualDdDeliver(item)">手动发货</a></p>
                        <p v-if="item.can_edit_dd_deliver == 1"><a href="javascript:;" class="details" @click="bindEditDdDeliver(item)">修改运单</a></p>
                        <p v-if="canShowAlibabaPurchase(item)"><a href="javascript:;" class="details" @click="bindAlibabaPurchaseNew(item)">{{ item.pdd_status == 102 ? '重采失败组' : '厂家直采' }}</a></p>
                        <p v-if="!item.pdd_order && !item.delete_time && item.ready_stock_amount && item.is_exception != 1"><a href="javascript:;" class="details" @click="bindStockPurchase(item)">仓库直发</a></p>
                        <p v-if="canShowCancelPurchaseUnpaid(item)"><a href="javascript:;" class="details" @click="delPurchase(item)">取消采购</a></p>
                        <p v-if="item.pdd_order && item.pdd_order?.order_id"><a href="javascript:;" class="details" @click="needSyncOrder(item)">同步采购</a></p>
                        <p><a href="javascript:;" class="details" @click="afterSales(item)">同步抖店</a></p>
                        <p v-if="item.pdd_order?.is_deal == 1"><a href="javascript:;" class="details">处理中</a></p>
                        <p v-if="item.pdd_order && item.pdd_order?.order_id && item.pdd_order?.status!=90 && item.pdd_order?.status!=105"><a href="javascript:;" class="details">采购成功</a></p>
                        <p><a href="javascript:" class="details" v-if="item.pdd_order && item.pdd_order?.order_id && item.pdd_order?.status!=90 && item.pdd_order?.status_name=='待支付'" @click="toDoOrderPay(item)">去支付</a></p>
                        <p v-if="canShowCancelPurchasePaid(item)"><a href="javascript:;" class="details" @click="repealPurchase(item)">取消采购</a></p>
                        <!-- <p v-if="searchData.pdd_order_status < 130 && item.deliver_gift < 1"><a href="javascript:;" class="details" @click="sendGiftOrder(item.id)">发礼品单</a></p> -->
                        <p v-if="item.pdd_status  == 140"><a href="javascript:;" class="details" @click="setNotDeal(item.id)">完结</a></p>
                        <p v-if="!item.pdd_order && !item.delete_time"><a href="javascript:;" class="details" @click="postDeleteOrder(item.id)">删除</a></p>
                        <p v-if="!item.pdd_order && item.delete_time > 0"><a href="javascript:;" class="details" @click="cancelDelete(item)">恢复</a></p>
                      </div>
                    </div>

                    <div class="order_remarks" v-if="item.pdd_msg">
                      <div class="remarks_item">
                        <p class="txt red">采购备注：</p>
                        <p class="remarks red">{{ item.pdd_msg ?? '利润差太低' }}</p>
                      </div>
                    </div>
                    <div class="order_remarks">
                      <div class="remarks_item">
                        <p class="txt">买家留言：</p>
                        <p class="remarks">{{ item.buyer_words }}</p>
                      </div>
                      <div class="remarks_item">
                        <p class="txt">商家留言：</p>
                        <p class="remarks">
                          <span>{{ item.order.seller_words }}</span>
                          <!-- <i class="iconfont el-icon-edit" @click="showRemark2(item.order_id)"></i> -->
                          <span :label="star.val" v-for="(star,index) in arrStar" :key="index" v-if="item.order.seller_remark_stars==star.val">
														<i class="star" :class="star.icon" :style="{'color':star.color}"></i>
													</span>
                          <span @click="showRemark(item.order_id)"
                                style="cursor: pointer;text-align: justify;">
														<i class="el-icon-edit" style="margin-left: 5px;"></i>
													</span>
                        </p>
                      </div>
                    </div>

                    <div class="order_remarks" v-if="item.pdd_order?.return_logistics_code">
                      <div class="remarks_item">
                        <p class="txt">平台退货单号：</p>
                        <p class="remarks">{{ item.pdd_order?.return_logistics_code }}</p>
                      </div>
                      <div class="remarks_item">
                        <p class="txt">买家退货单号：</p>
                        <p class="remarks">{{ item.order_after_sales?.return_logistics_code }}</p>
                      </div>
                    </div>

                    <div class="order_remarks" v-if="item.pdd_order?.pdd_return_address?.id > 0">
                      <div class="remarks_item">
                        <p class="txt">退货地址：</p>
                        <p class="remarks">{{ item.pdd_order?.pdd_return_address_encrypt }}
                          <i class="el-icon-refresh" style="margin-left: 5px;cursor: pointer;" @click="refreshReturnAddress(item)"></i>
                          <i class="el-icon-edit" style="margin-left: 5px;cursor: pointer;" @click="editAddress(item.pdd_order.pdd_return_encrypt_address)"></i>
                        </p>
                      </div>
                    </div>

                  </li>
                </el-checkbox-group>
                <li class="nodata" v-if="page_data.total == 0">暂无数据</li>
              </ul>
              <div class="turn_page">
                <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getList" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10,50,100]"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 收货地址信息弹窗 -->
      <orderAddress @close="dialog.addressDialog = false" :isLoading.sync="isLoading" :show.sync="dialog.addressDialog" :order_id.sync="order_id"></orderAddress>
      <!-- 标记备注弹窗 -->
      <orderRemark @close="dialog.remarkDialog = false" @complete="refresh()" :isLoading.sync="isLoading" :show.sync="dialog.remarkDialog" :order_id.sync="order_id"></orderRemark>
      <!-- 售后详情弹窗 -->
      <el-dialog title="售后详情" :visible.sync="dialog.aftersaleDialog" width="70%" center>
        <orderAfterSales @close="dialog.aftersaleDialog = false" @complete="refresh()" :isLoading.sync="isLoading" :show.sync="dialog.aftersaleDialog" :info.sync="order_product"></orderAfterSales>
      </el-dialog>
      <!-- 组合采购：全部 1688 单号 -->
      <el-dialog
          title="1688采购单号"
          :visible.sync="dialog.alibabaOrderIdsDialog"
          width="480px"
          append-to-body
          @closed="alibabaOrderIdsDialogList = []"
      >
        <ul class="baba-order-ids-list">
          <li v-for="oid in alibabaOrderIdsDialogList" :key="oid">
            <span class="order-id-link" @click.stop="openAlibabaOrderById(oid)">{{ oid }}</span>
            <i class="iconfont icon-fuzhi" @click.stop="bindCopy(oid)"></i>
          </li>
        </ul>
      </el-dialog>
      <!-- 删除订单二次确认 -->
      <el-dialog
          title="提示"
          :visible.sync="dialog.deleteOrderDialog"
          width="420px"
          append-to-body
          :close-on-click-modal="false"
          @closed="onDeleteOrderDialogClosed"
      >
        <div class="delete-order-confirm">
          <p class="delete-order-confirm__tip">确认删除操作?</p>
          <el-input
              v-model="deleteConfirmText"
              placeholder="请输入确认删除"
              size="small"
              clearable
              @keyup.enter.native="confirmDeleteOrder"
          ></el-input>
          <p class="delete-order-confirm__hint">输入<span class="red">“确认删除”</span>后才能删除订单</p>
        </div>
        <span slot="footer" class="dialog-footer">
					<el-button size="small" @click="dialog.deleteOrderDialog = false">取消</el-button>
					<el-button
              type="primary"
              size="small"
              :disabled="deleteConfirmText !== '确认删除'"
              @click="confirmDeleteOrder"
          >确定</el-button>
				</span>
      </el-dialog>
      <!-- 选择拼多多账号 -->
      <pddAccountConfirm ref="pddAccountConfirm" :ali_order_type="ali_order_type" />
      <SetAutoGift ref="SetAutoGift"/>
      <modifyConfirm ref="modifyConfirm" @refresh="refresh"/>
      <modifyReturnAddress ref="modifyReturnAddress"/>
      <orderReturnAddress ref="orderReturnAddress"  @close="initFilterData(),getList()"/>
      <modifyConfirmOrderNo ref="modifyConfirmOrderNo" @refresh="refresh"/>
      <!-- 订单支付弹窗 -->
      <orderPay @close="dialog.payDialog = false" @success="$router.go(0)" :show.sync="dialog.payDialog" :order_id.sync="order_id"></orderPay>
      <!-- 同步订单弹窗 -->
      <syncOrder @close="dialog.syncOrderDialog = false" :isLoading.sync="isLoading" :show.sync="dialog.syncOrderDialog"></syncOrder>
      <!-- 客服备注弹窗 -->
      <serviceRemark @close="dialog.remark2Dialog = false" @complete="refresh()" :isLoading.sync="isLoading" :show.sync="dialog.remark2Dialog" :order_id.sync="order_id"></serviceRemark>
    </div>
    <myFoot></myFoot>
    <connectGood ref="child" :dataArr="cg_data"></connectGood>
    <alibabaGoodsConnect ref="alibaba" :dataArr="cg_data"></alibabaGoodsConnect>
    <batchAlibabaConnect ref="batchAlibabaConnect" @refresh="onBatchAlibabaConnectRefresh"></batchAlibabaConnect>
    <markProblemOrder ref="markProblemOrder" />
    <ddDeliverDialog ref="ddDeliverDialog" />
    <syncDdOrderQueue ref="syncDdOrderQueue" :isLoading.sync="isLoading" :show.sync="dialog.syncDdOrderQueueDialog" @close="initFilterData(),dialog.syncDdOrderQueueDialog=false"></syncDdOrderQueue>
  </div>
</template>

<script>
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import ucMenu from '../../components/ucenterMenu/ucmenu';
import orderAddress from './components/orderAddress/orderAddress';
import orderRemark from './components/orderRemark/orderRemark';
import serviceRemark from './components/serviceRemark/serviceRemark';
import connectGood from './components/connectGood/connectGood';
import orderAfterSales from './components/orderAfterSales/orderAfterSales';
import orderPay from './components/orderPay/orderPay';
import syncOrder from './components/syncOrder/syncOrder';
import Pagination from '../../components/pagination/pagination';
import pddAccountConfirm from "./components/pdd_account_confirm/index.vue";
import modifyConfirm from "./components/modify_confirm/index.vue";
import modifyConfirmOrderNo from "./components/modify_confirm_order_no/index.vue";
import modifyReturnAddress from "./components/modify_return_address/index.vue";
import orderReturnAddress from "./components/order_return_address/index.vue";
import SetAutoGift from "./components/set_auto_gift/index.vue";
import {Loading} from 'element-ui';
import {mapActions, mapState,} from "vuex";
/*import headDefault from "@/assets/images/head.png";*/
import alibabaGoodsConnect from './components/alibaba_goods_connect/index.vue';
import batchAlibabaConnect from './components/batch_alibaba_connect/index.vue';
import markProblemOrder from './components/mark_problem_order/index.vue';
import ddDeliverDialog from './components/dd_deliver_dialog/index.vue';
import syncDdOrderQueue from './components/sync_dd_order/index.vue';
export default {
  name: "ucenterOrders",
  data() {
    return {
      order_id: 0,
      options: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      arrStatus: [],
      shopTypeList: [],
      arrStar: [],
      arrShop: [],
      arrAbnormal: [],
      arrProblemType: [],
      arrLinkStatus: [],
      arrRemarkFilter: [],
      arrYesNoLayout: [],
      arrChildOrderNumFilter: [],
      arrProvince: [],
      arrAfterSales: [],
      arrPddStatus: [],
      arrDamagedFilter: [],
      sync_order_queue_count: 0,
      checkAll: false,
      checkList: [],
      isLoading: false,
      list: [],
      page_data: {
        limit: 10,
        page: 1,
        total: 0,
      },
      total_partner_profit: 0,
      damaged_total_amount: 0,
      searchData: {},
      dialog: {
        addressDialog: false,
        aftersaleDialog: false,
        remarkDialog: false,
        remark2Dialog: false,
        payDialog: false,
        syncOrderDialog: false,
        syncDdOrderQueueDialog: false,
        deleteOrderDialog: false,
        alibabaOrderIdsDialog: false,
      },
      alibabaOrderIdsDialogList: [],
      deleteConfirmText: '',
      deleteConfirmIds: '',
      cg_data: "",
      order_product: [],
      is_decrypt: 0,
      decrypt_state: 1,
      decrypt_msg: '',
      loading_service_id: 0,
      userinfo: {},
      isHideOrderInfo: false,
      ali_order_type: 0,
      platformTypeList: [
        {
          val: 1,
          text: '多多订单'
        },
        {
          val: 2,
          text: '巴巴订单'
        }
      ],
      firstLoad: true,
      groupList: [],
      nowTick: Date.now(),
      countdownTimer: null,
    }
  },
  components: {
    myHead, myFoot, ucMenu, orderAddress, connectGood, orderAfterSales, orderRemark, serviceRemark, orderPay, Pagination, syncOrder, pddAccountConfirm, modifyConfirm, modifyConfirmOrderNo, modifyReturnAddress,orderReturnAddress,SetAutoGift,alibabaGoodsConnect,batchAlibabaConnect,syncDdOrderQueue,markProblemOrder,ddDeliverDialog
  },
  mounted(){
    const isHideInfo = localStorage.getItem('isHideInfo')
    if(isHideInfo == 1){
      this.isHideOrderInfo = true
    }
    this.countdownTimer = setInterval(() => {
      this.nowTick = Date.now()
    }, 1000)
    // if(this.userinfo){
    // 	this.refreshUserinfo()
    // }
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
      this.countdownTimer = null
    }
  },
  computed:{
    ...mapState({
      users:(state)=>state.login.userinfo,
    }),
    isDamagedSearch() {
      return !!(this.searchData.damaged_filter
          || (this.searchData.damaged_time && this.searchData.damaged_time.length));
    },
  },
  created() {
    var query = this.$route.query
    if (query.status) {
      this.searchData.pdd_order_status = Number(query.status)
    }
    if (query.after_sale) {
      this.searchData.after_sale_status = Number(query.after_sale)
    }
    if (query.damaged_filter) {
      this.searchData.damaged_filter = query.damaged_filter
    }
    if (query.damaged_time_start && query.damaged_time_end) {
      this.searchData.damaged_time = [query.damaged_time_start, query.damaged_time_end]
    }
    if(this.users){
      this.userinfo = this.users
    }
    this.getList()
    this.loadGroupList()

  },
  methods: {
    loadGroupList() {
      this.getShopBoardGroupList({
        data: {},
        success: (res) => {
          if (res.code === 200) {
            this.groupList = res.data || [];
          } else {
            this.$message.error(res.message || '获取分组失败');
          }
        }
      });
    },
    callCG(arr) {//打开子组件店铺列表
      this.cg_data = JSON.stringify(arr)
      this.$refs.child.showConnectGood()
    },
    getAftersaleCountdownText(item) {
      void this.nowTick
      const aftersale = item && item.order_after_sales
      if (!aftersale) return ''
      const raw = aftersale.status_deadline
      let ts = parseInt(raw, 10)
      if (!ts || ts <= 0) return ''
      const endMs = ts < 1e12 ? ts * 1000 : ts
      const left = Math.floor((endMs - Date.now()) / 1000)
      if (left <= 0) return '00 秒'
      const d = Math.floor(left / 86400)
      const restAfterDay = left % 86400
      const h = Math.floor(restAfterDay / 3600)
      const m = Math.floor((restAfterDay % 3600) / 60)
      const s = restAfterDay % 60
      const parts = []
      if (d > 0) parts.push(`${d} 天`)
      if (d > 0 || h > 0) parts.push(`${h} 小时`)
      parts.push(`${m} 分`, `${s} 秒`)
      return parts.join(' ')
    },
    goOrderAftersaleDetail(item) {
      const aftersale = item && item.order_after_sales
      if (!aftersale || !aftersale.id) {
        this.$message({ message: '缺少售后记录 ID', type: 'warning' })
        return
      }
      const route = this.$router.resolve({
        path: '/uc_after_sales_detail',
        query: { id: String(aftersale.id) },
      })
      window.open(route.href, '_blank')
    },
    alibabaCG(arr) {//打开子组件店铺列表（须先写入 cg_data，再打开弹窗，否则会读到上一次数据）
      this.cg_data = JSON.stringify(arr)
      this.$refs.alibaba.showConnectGood()
    },
    /** 厂家直采 pdd_code 有效：非空且不包含「规格失效」 */
    isValidAlibabaPddCode(item) {
      const c = item && item.pdd_code
      if (c === undefined || c === null || String(c).trim() === '') return false
      if (String(c).includes('规格失效')) return false
      return true
    },
    isAlibabaDirectLinked(item) {
      if (item && item.alibaba_items && item.alibaba_items.length) return true
      return Number(item.source_type) === 2 && this.isValidAlibabaPddCode(item)
    },
    /** 采购状态文案（含 102）；FE-B；2026-08-17 */
    getPurchaseStatusText(item) {
      if (item?.pdd_order?.status_name) return item.pdd_order.status_name
      if (item?.pdd_status_text) return item.pdd_status_text
      if (item?.abb_purchase_msg) return item.abb_purchase_msg
      return '暂无'
    },
    /** 厂家直采 / 102 重采失败组入口；抖店已取消不展示 */
    canShowAlibabaPurchase(item) {
      if (!item || item.delete_time || Number(item.is_exception) === 1 || Number(item.is_abnormal) > 0) return false
      if (this.isDdOrderClosedForCancelPurchase(item)) return false
      if (Number(item.source_type) !== 2) return false
      const st = Number(item.pdd_status || 0)
      if (st === 102 || st === 101) return true
      return !item.pdd_order
    },
    /**
     * 采购单详情：按 1688 采购单（alibaba_order_id / 卖家组）分组展示
     * 改动目的：列表按每个采购单显示；时间：2026-08-17
     */
    getPurchaseGroups(item) {
      if (!item) return []
      const lines = Array.isArray(item.alibaba_items) ? item.alibaba_items : []
      if (lines.length) {
        const map = {}
        lines.forEach((line) => {
          const oid = String(line.alibaba_order_id || '').trim()
          const gkey = String(line.seller_group_key || line.albb_seller_id || 'pending')
          const key = oid || ('wait_' + gkey)
          if (!map[key]) {
            map[key] = {
              key,
              alibaba_order_id: oid,
              seller_group_key: gkey,
              wangwang_account: String(line.wangwang_account || ''),
              lines: [],
              has_fail: false,
              is_frozen: true,
              tracking_list: [],
              status_text: '',
              status_code: 0,
              account_text: item.pdd_order?.buy_mode == 3 ? '厂家直采' : (item.pdd_order?.account || ''),
              express_no: '',
              link: null,
              pdd_pay_amount: Number(line.pdd_pay_amount || 0),
              shipping_fee: Number(line.shipping_fee || 0),
              total_amount: Number(line.total_amount || 0),
              alibaba_status: String(line.alibaba_status || ''),
            }
          }
          map[key].lines.push(line)
          if (Number(line.pdd_pay_amount || 0) > 0 || Number(line.shipping_fee || 0) > 0) {
            map[key].pdd_pay_amount = Number(line.pdd_pay_amount || 0)
            map[key].shipping_fee = Number(line.shipping_fee || 0)
            map[key].total_amount = Number(line.total_amount || (Number(line.pdd_pay_amount || 0) + Number(line.shipping_fee || 0)))
          }
          if (line.alibaba_status) {
            map[key].alibaba_status = String(line.alibaba_status)
          }
          if (Number(line.line_status) === 90 || Number(line.line_status) === 100) {
            map[key].has_fail = true
          }
          if (Number(line.is_frozen) !== 1) {
            map[key].is_frozen = false
          }
          if (!map[key].wangwang_account && line.wangwang_account) {
            map[key].wangwang_account = line.wangwang_account
          }
          if (line.tracking_no) {
            const exists = map[key].tracking_list.some(t => t.no === line.tracking_no)
            if (!exists) {
              map[key].tracking_list.push({
                no: line.tracking_no,
                main: Number(line.is_dd_main_ship) === 1,
              })
            }
          }
          // 组状态取「最差」：失败 > 待采 > 成功文案
          const st = Number(line.line_status || 0)
          if (!map[key].status_text || st === 90 || st === 100) {
            map[key].status_text = line.line_status_text || ''
            map[key].status_code = st
          }
        })
        return Object.values(map)
      }
      if (this.isAlibabaDirectLinked(item) || (item.pdd_order && item.pdd_order.order_id)) {
        const oid = String(item.pdd_order?.order_id || item.order_alibaba_order?.alibaba_order_id || '')
        return [{
          key: 'legacy_' + (oid || item.id),
          alibaba_order_id: oid,
          wangwang_account: item.alibaba_direct_link?.wangwang_account || '',
          lines: [],
          has_fail: Number(item.pdd_status) === 101 || Number(item.pdd_status) === 102,
          is_frozen: false,
          tracking_list: item.pdd_order?.express_no ? [{ no: item.pdd_order.express_no, main: true }] : [],
          status_text: this.getPurchaseStatusText(item),
          status_code: Number(item.pdd_status || item.pdd_order?.status || 0),
          account_text: item.pdd_order?.buy_mode == 3 ? '厂家直采' : (item.pdd_order?.account || ''),
          express_no: item.pdd_order?.express_no || '',
          link: item.alibaba_direct_link || null,
          pdd_pay_amount: Number(item.pdd_order?.pdd_pay_amount || 0),
          shipping_fee: Number(item.pdd_order?.shipping_fee || item.pdd_order?.freight || 0),
          total_amount: Number(item.pdd_order?.pdd_pay_amount || 0) + Number(item.pdd_order?.shipping_fee || item.pdd_order?.freight || 0),
          alibaba_status: String(item.order_alibaba_order?.alibaba_status || ''),
        }]
      }
      return []
    },
    openAlibabaOrderById(orderId) {
      const id = String(orderId || '').trim()
      if (!id) return
      this.openAlibabaOrderDetail({ buy_mode: 3, order_id: id })
    },
    /** 组合采购下全部有效 1688 主单号（去重） */
    getAlibabaOrderIds(item) {
      const ids = []
      const seen = {}
      const push = (id) => {
        const s = String(id || '').trim()
        if (!s || seen[s]) return
        seen[s] = true
        ids.push(s)
      }
      this.getPurchaseGroups(item).forEach((g) => push(g.alibaba_order_id))
      if (!ids.length) {
        push(item?.pdd_order?.order_id)
        push(item?.order_alibaba_order?.alibaba_order_id)
      }
      return ids
    },
    hasMultipleAlibabaOrders(item) {
      return Number(item?.pdd_order?.buy_mode) === 3 && this.getAlibabaOrderIds(item).length > 1
    },
    openAlibabaOrderIdsDialog(item) {
      this.alibabaOrderIdsDialogList = this.getAlibabaOrderIds(item)
      if (this.alibabaOrderIdsDialogList.length <= 1) {
        const only = this.alibabaOrderIdsDialogList[0] || item?.pdd_order?.order_id
        if (only) this.bindCopy(only)
        return
      }
      this.dialog.alibabaOrderIdsDialog = true
    },
    canEditAlibabaDirectLink(item) {
      return true;//所有状态都可以关联


      // if (!item) return false
      // const pddOk =
      // 	item.pdd_status === 0 ||
      // 	item.pdd_status === 100 ||
      // 	(item.pdd_status === 140 && item.is_exchange === 1 && !String(item.dd_order_id || '').includes('B'))
      // const orderOk = item.order_status !== 1 && item.order_status !== 4
      // return pddOk && orderOk
    },
    getPurchaseReturnAddressInfo(item, group) {
      const map = item && item.purchase_return_addresses && typeof item.purchase_return_addresses === 'object'
          ? item.purchase_return_addresses
          : null
      const oid = String(group?.alibaba_order_id || '').trim()
      if (map && oid && map[oid]) return map[oid]
      if (map && map._default) return map._default
      return {
        state: Number(item?.return_address_state ?? 10),
        error: String(item?.return_address_error || ''),
        state_text: String(item?.return_address_state_text || ''),
        origin_detail: '',
        merchant_address_text: '',
      }
    },
    getPurchaseReturnAddressState(item, group) {
      return Number(this.getPurchaseReturnAddressInfo(item, group).state ?? 10)
    },
    getPurchaseReturnAddressError(item, group) {
      return String(this.getPurchaseReturnAddressInfo(item, group).error || '')
    },
    getPurchaseReturnAddressLabel(item, group) {
      const text = String(this.getPurchaseReturnAddressInfo(item, group).state_text || '').trim()
      if (!text) return '未设置'
      const matched = text.match(/^\d{4}\/\d{2}\/\d{2}\s+\d{2}:\d{2}:\d{2}\s+(.+)$/)
      return matched ? matched[1] : text
    },
    getPurchaseReturnAddressTime(item, group) {
      const text = String(this.getPurchaseReturnAddressInfo(item, group).state_text || '').trim()
      const matched = text.match(/^(\d{4}\/\d{2}\/\d{2}\s+\d{2}:\d{2}:\d{2})/)
      return matched ? matched[1] : ''
    },
    getPurchaseReturnAddressClass(item, group) {
      const state = this.getPurchaseReturnAddressState(item, group)
      if (state === 30) return 'is-success'
      if (state <= 0) return 'is-error'
      if (state <= 10) return 'is-pending'
      return 'is-processing'
    },
    openAlibabaWangwangChat(wangwangAccount) {
      const account = String(wangwangAccount || '').trim()
      if (!account) {
        this.$message({ message: '暂无上家旺旺', type: 'warning' })
        return
      }
      const wangwangId = account.replace(/^cnalichn/i, '')
      const touid = encodeURIComponent('cnalichn' + wangwangId)
      const url = `https://air.1688.com/app/ocms-fusion-components-1688/def_cbu_web_im/index.html?&touid=${touid}&siteid=cnalichn&status=1&portalId=&gid=&offerId=&itemsId=&spmid=a261y.7663282.0#/`
      window.open(url, '_blank')
    },
    getAlibabaOfferDetailUrl(offerId) {
      const id = String(offerId || '').trim()
      if (!id) return ''
      return `https://detail.1688.com/offer/${id}.html?offerId=${id}`
    },
    openAlibabaOfferDetail(offerId) {
      const url = this.getAlibabaOfferDetailUrl(offerId)
      if (!url) {
        this.$message({ message: '暂无1688商品链接', type: 'warning' })
        return
      }
      window.open(url, '_blank')
    },
    isAlibabaPurchaseOrder(pddOrder) {
      return Number(pddOrder && pddOrder.buy_mode) === 3 && !!String(pddOrder.order_id || '').trim()
    },
    getAlibabaOrderDetailUrl(pddOrder) {
      if (!this.isAlibabaPurchaseOrder(pddOrder)) return ''
      const orderId = String(pddOrder.order_id).trim()
      return `https://air.1688.com/app/ctf-page/trade-order-detail/index.html?orderId=${encodeURIComponent(orderId)}`
    },
    openAlibabaOrderDetail(pddOrder) {
      const url = this.getAlibabaOrderDetailUrl(pddOrder)
      if (!url) return
      window.open(url, '_blank')
    },
    openBatchAlibabaConnect() {
      if (!this.checkList.length) {
        this.$message({ message: '请先勾选订单', type: 'warning' })
        return
      }
      const bySku = new Map()
      for (const id of this.checkList) {
        const row = this.list.find((i) => i.id === id)
        if (!row) continue
        const key =
            row.sku_id != null && row.sku_id !== ''
                ? String(row.sku_id)
                : `id_${row.id}`
        if (!bySku.has(key)) bySku.set(key, row)
      }
      const items = [...bySku.values()]
      if (!items.length) {
        this.$message({ message: '未找到勾选订单数据', type: 'warning' })
        return
      }
      this.$refs.batchAlibabaConnect.open(items)
    },
    onBatchAlibabaConnectRefresh() {
      this.getList(true, () => {
        const batch = this.$refs.batchAlibabaConnect
        if (batch && batch.visible) {
          batch.syncSkuItemsFromList(this.list)
        }
      })
    },
    ...mapActions({
      getOrderManageList: "ucenter_order/getOrderManageList",
      getOrderManageAddressInfo: "ucenter_order/getOrderManageAddressInfo",
      getOrderManageDetail: "ucenter_order/getOrderManageDetail",
      getOrderManageFilterData: "ucenter_order/getOrderManageFilterData",
      opOrderManageBatPurchase: "ucenter_order/opOrderManageBatPurchase",
      opOrderManageCheckAliOrderType: "ucenter_order/opOrderManageCheckAliOrderType",
      opOrderManageBatAbnormal: "ucenter_order/opOrderManageBatAbnormal",
      opOrderManageBatchMarkException: "ucenter_order/opOrderManageBatchMarkException",
      opOrderManageReceipt: "ucenter_order/opOrderManageReceipt",
      opDdShopRefreshDecrypt: "ucenter_order/opDdShopRefreshDecrypt",
      opUnDecrypt: "ucenter_order/opUnDecrypt",
      opReDecrypt: "ucenter_order/opReDecrypt",
      opOrderManageDeleteProduct: "ucenter_order/opOrderManageDeleteProduct",
      opOrderManageDelPddOrder: "ucenter_order/opOrderManageDelPddOrder",
      opOrderManageSendGiftOrder: "ucenter_order/opOrderManageSendGiftOrder",
      opOrderManageSetNotDealOrder: "ucenter_order/opOrderManageSetNotDealOrder",
      opOrderManageRepealPurchase: "ucenter_order/opOrderManageRepealPurchase",
      opOrderManageNeedSyncPddOrder: "ucenter_order/opOrderManageNeedSyncPddOrder",
      opOrderManageFetchAlibabaSendTime: "ucenter_order/opOrderManageFetchAlibabaSendTime",
      opOrderManageUpdateOrderAfterSale: "ucenter_order/opOrderManageUpdateOrderAfterSale",
      opOrderManageCancelDelete: "ucenter_order/opOrderManageCancelDelete",
      opRefreshReturnAddress: "ucenter_order/opRefreshReturnAddress",
      opSetSellerWords: "ucenter_order/opSetSellerWords",
      opUpdatePddAccount: "ucenter_order/opUpdatePddAccount",
      opUpdatePddOrderNo: "ucenter_order/opUpdatePddOrderNo",
      opUpdateOrderProduct: "ucenter_order/opUpdateOrderProduct",
      opUpdateBuyMode: "ucenter_order/opUpdateBuyMode",
      opSetPddReturnAddress: "ucenter_order/opSetPddReturnAddress",
      opSetAutoSendGift: "ucenter_order/opSetAutoSendGift",
      opDoOrderPay: "ucenter_order/opDoOrderPay",
      getShopBoardGroupList: "shop_board/getShopBoardGroupList",
      GetQuerySkuRelativeInfo: "ucenter_order/GetQuerySkuRelativeInfo",
    }),
    querySkuPermanentRelative(item) {
      const skuId = item && item.sku_id != null ? String(item.sku_id).trim() : ''
      if (!skuId || skuId === '0') {
        this.$message({ message: '暂无规格ID', type: 'warning' })
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '查询中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.2)'
      })
      this.GetQuerySkuRelativeInfo({
        data: { sku_id: skuId },
        success: (res) => {
          loading.close()
          if (res.code == 200) {
            const offerIds = this.resolvePermanentOfferIds(res.data)
            if (!offerIds.length) {
              this.$message({ type: 'error', message: '未解析到已关联的1688商品' })
              return
            }
            const linksHtml = offerIds.map((id, idx) => {
              const url = this.getAlibabaOfferDetailUrl(id)
              const label = '关联' + (idx + 1)
              if (!url) return `<span>${label}</span>`
              return `<a class="query_permanent_offer_link" style="color: #409EFF;	cursor: pointer;	text-decoration: none;" href="${url}" target="_blank" rel="noopener">${label}</a>`
            }).join('、')
            this.$alert(`<p class="query_permanent_yes">是</p><p class="query_permanent_offers">${linksHtml}</p>`, '永久关联查询', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '关闭',
              type: 'success',
              center: true,
            }).catch(() => {})
          } else {
            this.$message({
              type: 'error',
              message: res.msg || '查询失败'
            })
          }
        },
        error: () => {
          loading.close()
          this.$message({ type: 'error', message: '查询失败' })
        }
      })
    },
    /** 永久关联接口：offers / source_product_ids / 旧 source_product_id */
    resolvePermanentOfferIds(data) {
      if (!data) return []
      if (Array.isArray(data.offers) && data.offers.length) {
        const ids = data.offers.map(o => String((o && (o.alibaba_goods_id || o.source_product_id)) || '').trim()).filter(Boolean)
        if (ids.length) return ids
      }
      if (Array.isArray(data.source_product_ids) && data.source_product_ids.length) {
        return data.source_product_ids.map(id => String(id || '').trim()).filter(Boolean)
      }
      const one = String(data.source_product_id || '').trim()
      return one ? [one] : []
    },
    initFilterData() {
      this.getOrderManageFilterData({
        data: this.searchData, success: (res) => {
          if (res.code === 200) {
            // console.log('get goods filter data',res)
            this.arrStatus = res.data.arr_status
            this.arrStar = res.data.arr_star
            this.arrAbnormal = res.data.arr_abnormal
            this.arrProblemType = res.data.arr_problem_type || []
            this.arrLinkStatus = res.data.arr_link_status || []
            this.arrRemarkFilter = res.data.arr_remark_filter || []
            this.arrYesNoLayout = res.data.arr_yes_no_layout || []
            this.arrChildOrderNumFilter = res.data.arr_child_order_num_filter || []
            this.arrProvince = res.data.arr_province || []
            this.arrAfterSales = res.data.arr_after_sales
            this.arrShop = res.data.arr_shop
            this.shopTypeList = res.data.shop_types
            this.arrPddStatus = res.data.arr_pdd_status
            this.arrDamagedFilter = res.data.arr_damaged_filter || []
            this.sync_order_queue_count = res.data.sync_order_queue_count
            if(this.firstLoad){
              this.firstLoad = false
              for(let i=0;i<this.arrPddStatus.length;i++){
                if(this.arrPddStatus[i].val == 122){
                  //弹窗提示获取退货地址失败订单数
                  if(this.arrPddStatus[i].num > 0){
                    this.$alert('获取退货地址失败订单数：'+this.arrPddStatus[i].num, '提示', {
                      confirmButtonText: '查看',
                      cancelButtonText: '取消',
                      center: true,
                      showCancelButton: true,
                      type: 'warning',
                      callback: (action) => {
                        if(action == 'confirm'){
                          this.changeStatus(122)
                        }
                      }
                    })
                  }

                }
              }
            }

          }
        }
      })
    },
    buildListParam(extra = {}) {
      let param = {limit: this.page_data.limit, page: this.page_data.page}
      // 如果是空数组 → 转成空字符串
      if (Array.isArray(this.searchData.group_ids) && this.searchData.group_ids.length === 0) {
        param.group_ids = '';
      }else if (!this.searchData.group_ids) {
        param.group_ids = '';
      }
      param = Object.assign(param, this.searchData, extra)
      ;['problem_types', 'seller_remark_stars', 'remark_filters', 'province_ids', 'multi_child_order'].forEach((key) => {
        if (Array.isArray(param[key])) {
          if (param[key].length) {
            param[key] = param[key].join(',')
          } else {
            delete param[key]
          }
        }
      })
      return param
    },
    //重置搜索
    resetSearch() {
      this.searchData = {}
      this.checkAll = false
      this.checkList = []
      this.getList()
    },
    //刷新列表
    refresh(nowPage = true) {
      if (!nowPage) {
        this.page_data.page = 1
      }
      this.checkAll = false
      this.checkList = []
      this.getList()
    },
    changeStatus(val) {
      this.searchData.pdd_order_status = val
      this.refresh(false)
    },
    doSearch() {
      this.page_data.page = 1
      this.checkAll = false
      this.checkList = []
      this.getList()
    },
    getList(showLoading = true, onDone) {
      if (showLoading) this.isLoading = true
      let loadingInstance = Loading.service({fullscreen: true});

      let param = this.buildListParam()
      this.getOrderManageList({
        data: param, success: (res) => {
          if (res.code === 200) {
            // console.log('get order list',res)
            this.list = res.data.data
            this.page_data.total = res.data.total
            this.is_decrypt = res.data.is_decrypt
            this.decrypt_state = res.data.decrypt_state
            this.decrypt_msg = res.data.decrypt_msg
            this.total_partner_profit = res.data.total_partner_profit
            this.damaged_total_amount = res.data.damaged_total_amount || 0
            this.initFilterData()
          } else {
            this.$message({message: res.msg, type: 'error',});
          }
          this.isLoading = false
          loadingInstance.close()
          if (typeof onDone === 'function') {
            this.$nextTick(onDone)
          }
        }
      })
    },
    showAddressInfo(id) {
      this.order_id = id
      this.dialog.addressDialog = true
    },
    showOrderInfo(){
      //获取缓存数据
      const isHideInfo = localStorage.getItem('isHideInfo');

      if (isHideInfo == 1) {
        // 如果存在缓存数据，则将其解析为 JSON 对象
        localStorage.setItem('isHideInfo',0)
        this.isHideOrderInfo = false
      } else {
        localStorage.setItem('isHideInfo',1)
        this.isHideOrderInfo = true
      }
    },
    showRemark(id) {
      this.order_id = id
      this.dialog.remarkDialog = true
    },
    showRemark2(id) {
      this.order_id = id
      this.dialog.remark2Dialog = true
    },
    showAfterSaleInfo(order_product) {
      this.order_product = order_product
      this.dialog.aftersaleDialog = true
    },
    showPurchaseMsg(order_product) {
      this.$alert(order_product.purchase_msg, '采购状态', {
        type: 'warning',
        center: true
      });
    },
    bindCopy(text) {
      var str = ''
      var input = document.createElement("input"); // 创建input对象
      input.value = text; // 设置复制内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      this.$message({
        message: '复制成功',
        type: 'success'
      });

    },
    //全选
    bindCheckAll() {
      let checkAll = this.checkAll
      let list = this.list
      let checkList = []
      if (checkAll) {
        for (var i in list) {
          if (checkAll) {
            checkList.push(list[i].id)
          }
        }
      }
      this.checkList = checkList
    },
    //单项选
    bindCheckList() {
      let checkList = this.checkList
      if (checkList.length == this.list.length) {
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    },
    //立即采购
    bindPurchase(row) {
      if (!row.is_authorize_print) {
        this.$message({
          type: 'error',
          message: '请先授权打单'
        })
        this.$router.push({name: 'ucenter'})
        return;
      }
      this.postPurchcase(row.id)
    },

    //批量厂家直采-新版
    bindBatAlibabaPurchase() {
      let that = this
      let checkList = this.checkList
      if (checkList.length == 0) {
        this.$message({ message: '请先选择需要采购的订单', type: 'error' })
        return;
      }
      const abnormalCount = this.list.filter(item => checkList.includes(item.id) && item.is_abnormal > 0).length
      if (abnormalCount > 0) {
        this.$message({ message: '所选订单包含问题单，问题单不支持厂家直采', type: 'error' })
        return;
      }
      const exceptionCount = this.list.filter(item => checkList.includes(item.id) && item.is_exception == 1).length
      if (exceptionCount > 0) {
        this.$message({ message: '所选订单包含异常订单，异常订单不支持采购', type: 'error' })
        return;
      }
      const shippedCount = this.list.filter(item => checkList.includes(item.id) && (item.can_manual_dd_deliver != 1 && (item.tracking_no || item.order_status == 3))).length
      if (shippedCount > 0) {
        this.$message({ message: '所选订单包含已发货订单，已发货订单不支持采购', type: 'error' })
        return;
      }
      let ids = checkList.join(',')
      this.$confirm('确认批量厂家直采操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        that.handleAlibabaPurchaseNew(ids)
      }).catch((res) => {
        console.log(res)
      });
    },
    //厂家直采-1688采购-新版
    bindAlibabaPurchaseNew(row){
      if (row.is_exception == 1) {
        this.$message({ message: '异常订单不支持采购，请先取消异常标记', type: 'error' })
        return
      }
      if (row.tracking_no || row.order_status == 3 || row.can_edit_dd_deliver == 1) {
        this.$message({ message: '订单已发货，不支持采购', type: 'error' })
        return
      }
      if (row.is_abnormal > 0) {
        this.$message({ message: '问题单不支持厂家直采，请先取消问题标记', type: 'error' })
        return
      }
      let that = this
      let ids = row.id
      this.$confirm(row.pdd_status == 102 ? '确认重采失败卖家组？（已成功冻结组不会重复采购）' : '确认厂家直采操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        that.handleAlibabaPurchaseNew(ids)
      }).catch((res) => {
        console.log(res)
      });
    },
    //提交厂家直采-1688采购-新版
    handleAlibabaPurchaseNew(ids){
      let that = this
      let param = {
        ids: ids,
        buy_mode: 3
      }
      that.opOrderManageBatPurchase({
        data: param,
        success: (res) => {
          that.$alert(res.msg, '提示', {
            type: 'success',
            center: true,
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            callback: (action) => {
              if (action == 'confirm') {
                that.refresh()
              } else if (action == 'cancel') {
                that.refresh()
              }
            }
          })
        }
      })
    },
    //厂家直采-1688采购-旧版
    bindAlibabaPurchaseOld(row){
      if (row.is_abnormal > 0) {
        this.$message({ message: '异常单不支持厂家直采，请先取消异常单标记', type: 'error' })
        return
      }
      let that = this
      let param = {
        ids:row.id,
        account_id: -1,
        buy_mode: 3,
        group_id: row.dd_shop.group_id
      }
      that.opOrderManageCheckAliOrderType({
        data: param,
        success: (res) => {
          if (res.code == 200) {
            if (res.data.ali_order_type[0].type == 2) {
              that.postPurchcase(param.ids,2,row.dd_shop.group_id)
            }else if (res.data.ali_order_type[0].type == 1){
              that.opOrderManageBatPurchase({
                data: param,
                success: (res) => {
                  if (res.code == 200) {
                    this.$message({
                      type: 'success',
                      message: res.msg
                    })
                    this.refresh()
                  } else {
                    this.$message({
                      type: 'error',
                      message: res.msg
                    });
                  }
                }
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        }
      })


    },
    //仓库直发
    bindStockPurchase(row) {
      if (row.is_exception == 1) {
        this.$message({ message: '异常订单不支持采购，请先取消异常标记', type: 'error' })
        return
      }
      let that = this
      let param = {
        ids:row.id,
        account_id: -1,
        buy_mode: 4
      }
      this.$confirm('确认仓库直发?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        that.opOrderManageBatPurchase({
          data: param,
          success: (res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              });
            }
          }
        })
      }).catch((res) => {
        console.log(res)
      });

    },
    //批量采购
    bindBatPurchase() {
      let checkList = this.checkList
      // todo 遍历
      const _list = {}
      this.list.map(item => {
        _list[item.id] = item.is_authorize_print
      })

      for (let id of this.checkList) {
        if (!_list[id]) {
          this.$message({
            type: 'error',
            message: '请先授权打单'
          })
          this.$router.push({name: 'ucenter'})
          return;
        }
      }
      let ids = checkList.join(',')
      this.postPurchcase(ids)
    },

    //批量取消采购
    bindBatCancelPurchase() {
      let checkList = this.checkList
      if (checkList.length == 0) {
        this.$message({message: '请勾选订单', type: 'error'})
        return;
      }
      // todo 遍历
      const _list = {}
      this.list.map(item => {
        _list[item.id] = item.is_authorize_print
      })

      for (let id of this.checkList) {
        if (!_list[id]) {
          this.$message({
            type: 'error',
            message: '请先授权打单'
          })
          this.$router.push({name: 'ucenter'})
          return;
        }
      }
      let ids = checkList.join(',')
      this.$confirm('确认取消采购操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        this.opOrderManageDelPddOrder({
          data: {ids: ids},
          success: (res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          }
        })
      }).catch((res) => {
        console.log(res)
      });
    },
    // 批量删除
    bindBatDelete() {
      let checkList = this.checkList
      let ids = checkList.join(',')
      this.postDeleteOrder(ids)
    },
    bindBatchMarkProblem() {
      this.$refs.markProblemOrder.openBatch(this.checkList, this.arrProblemType, () => {
        this.refresh()
      })
    },
    bindMarkProblem(item) {
      this.$refs.markProblemOrder.open(item, this.arrProblemType, () => {
        this.refresh()
      })
    },
    bindMarkException(item) {
      const state = item.is_exception == 1 ? 0 : 1
      const actionText = state === 1 ? '标记为异常订单' : '取消异常标记'
      this.$confirm(`确认${actionText}？异常订单不参与自动采购和手动采购。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opOrderManageBatchMarkException({
          data: { ids: String(item.id), state },
          success: (res) => {
            if (res.code == 200) {
              this.$message({ type: 'success', message: res.msg })
              this.refresh()
            } else {
              this.$message({ type: 'error', message: res.msg })
            }
          }
        })
      }).catch(() => {})
    },
    bindManualDdDeliver(item) {
      this.$refs.ddDeliverDialog.openManual(item, () => {
        this.refresh()
      })
    },
    bindEditDdDeliver(item) {
      this.$refs.ddDeliverDialog.openEdit(item, () => {
        this.refresh()
      })
    },
    bindBatchMarkException() {
      const checkList = this.checkList
      if (checkList.length === 0) {
        this.$message({ message: '请先选择需要标记的订单', type: 'error' })
        return
      }
      this.$confirm('确认将所选订单标记为异常？异常订单不参与自动采购和手动采购。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opOrderManageBatchMarkException({
          data: { ids: checkList.join(','), state: 1 },
          success: (res) => {
            if (res.code == 200) {
              this.$message({ type: 'success', message: res.msg })
              this.refresh()
            } else {
              this.$message({ type: 'error', message: res.msg })
            }
          }
        })
      }).catch(() => {})
    },
    cancelDelete(row) {
      this.$confirm('确认恢复操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        this.opOrderManageCancelDelete({
          data: {ids: row.id}, success: (res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          }
        })
      }).catch((res) => {
        console.log(res)
      });
    },
    postDeleteOrder(ids) {
      this.deleteConfirmIds = ids
      this.deleteConfirmText = ''
      this.dialog.deleteOrderDialog = true
    },
    onDeleteOrderDialogClosed() {
      this.deleteConfirmText = ''
      this.deleteConfirmIds = ''
    },
    confirmDeleteOrder() {
      if (this.deleteConfirmText !== '确认删除') {
        return
      }
      const ids = this.deleteConfirmIds
      this.dialog.deleteOrderDialog = false
      this.opOrderManageDeleteProduct({
        data: {ids: ids},
        success: (res) => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        }
      })
    },
    //采购请求
    postPurchcase(ids,ali_order_type = 0,group_id = '') {
      let that = this
      let param = {ids: ids, ali_order_type: ali_order_type,group_id: group_id}
      that.ali_order_type = ali_order_type
      this.$refs.pddAccountConfirm.open(
          param,
          this.opOrderManageBatPurchase,
          (res) => {
            if (res.code == 200) {
              that.$message({
                type: 'success',
                message: res.msg
              })
              that.refresh()
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              });
            }
          }
      )
    },
    //订单导出
    orderExport() {
      if (this.isLoading) return
      this.$confirm('确认导出订单操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        this.isLoading = true
        let loadingInstance = Loading.service({fullscreen: true});
        let param = this.buildListParam({is_export: 1, order_ids: this.checkList})
        this.getOrderManageList({
          data: param, success: (res) => {
            this.isLoading = false;
            loadingInstance.close()
            if (res.code === 200) {
              // window.open(res.data)
              window.location.href = res.data
            } else {
              this.$message({message: res.msg, type: 'error',});
            }
          }
        })
      }).catch((res) => {
        console.log(res)
      });
    },
    sendGiftOrder(id = null) {
      let checkList = this.checkList
      if (id !== null) {
        checkList = [id]
      }
      let ids = checkList.join(',')
      if (checkList.length === 0) {
        this.$message({message: '请勾选订单', type: 'error'})
        return;
      }
      this.$confirm('确认发送礼品单操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        this.opOrderManageSendGiftOrder({
          data: {ids: ids},
          success: (res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          }
        })
      }).catch((res) => {
        console.log(res)
      });
    },
    setNotDeal(id = null) {
      let checkList = this.checkList
      if (id !== null) {
        checkList = [id]
      }
      let ids = checkList.join(',');
      if (checkList.length === 0) {
        this.$message({message: '请勾选订单', type: 'error'})
        return;
      }
      this.$confirm('确认完结该订单? 确认后不可逆', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        this.opOrderManageSetNotDealOrder({
          data: {ids: ids},
          success: (res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          }
        })
      }).catch((res) => {
        console.log(res)
      });
    },
    openAutoGift(){
      let param = {}
      let that = this
      this.$refs.SetAutoGift.open(
          param,
          this.opSetAutoSendGift,
          (res) => {
            if (res.code == 200) {
              that.$message({
                type: 'success',
                message: res.msg
              })
              that.refresh()
            } else {
              that.$message({
                type: 'error',
                message: res.msg
              })
            }
          }
      )
    },
    datePick() {
      console.log(111)
    },
    //放弃解密
    unDecrypt(ids) {
      var that = this
      this.$confirm('确认放弃解密？', '提示', {
        confirmButtonText: 'YES',
        cancelButtonText: 'NO',
        type: 'info',
        center: true
      }).then(() => {

        that.opUnDecrypt({
          data: {ids: ids}, success: (res) => {
            if (res.code == 200) {
              that.$message({
                type: 'success',
                message: res.msg
              })
              that.refresh()
            } else {
              that.$message({
                type: 'error',
                message: res.msg
              })
            }
          }
        })

      })
    },
    //批量放弃解密
    batUnDecrypt() {
      let checkList = this.checkList
      let ids = checkList.join(',')
      this.unDecrypt(ids)
    },
    //恢复解密
    reDecrypt(ids) {
      var that = this
      this.$confirm('确认恢复解密？', '提示', {
        confirmButtonText: 'YES',
        cancelButtonText: 'NO',
        type: 'info',
        center: true
      }).then(() => {
        that.opReDecrypt({
          data: {ids: ids}, success: (res) => {
            if (res.code == 200) {
              that.$message({
                type: 'success',
                message: res.msg
              })
              that.refresh()
            } else {
              that.$message({
                type: 'error',
                message: res.msg
              })
            }
          }
        })

      })
    },
    //批量恢复解密
    batReDecrypt() {
      let checkList = this.checkList
      let ids = checkList.join(',')
      this.reDecrypt(ids)
    },
    delPurchase(row) {
      this.$confirm('确认取消采购操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        this.opOrderManageDelPddOrder({
          data: {ids: row.id},
          success: (res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          }
        })
      }).catch((res) => {
        console.log(res)
      });
    },
    /** 抖店已关闭/退款完结：不再展示取消采购类按钮 */
    isDdOrderClosedForCancelPurchase(item) {
      if (!item) return true
      const os = Number(item.order_status || 0)
      // 4已取消 / 21发货前退款完结 / 22发货后退款完结 / 39收货后退款完结
      return [4, 21, 22, 39].includes(os)
    },
    /** 采购单已终态（已取消/申请退款/退款完成） */
    isPurchaseTerminal(item) {
      const st = Number(item?.pdd_order?.status ?? item?.pdd_status ?? 0)
      // 90已取消 / 140申请退款 / 150退款完成
      return [90, 140, 150].includes(st)
    },
    /**
     * 操作列：未挂主单号时的「取消采购」（待付/下单中）
     * 改动目的：售后清空 order_id 后勿误显；时间：2026-08-19
     */
    canShowCancelPurchaseUnpaid(item) {
      if (!item?.pdd_order || item.delete_time) return false
      if (this.isDdOrderClosedForCancelPurchase(item)) return false
      if (this.isPurchaseTerminal(item)) return false
      const oid = String(item.pdd_order.order_id || '').trim()
      const st = Number(item.pdd_order.status || 0)
      // 仅：尚无主单号的在途采购，或本地已标取消待清（90 且仍可操作的历史场景不再开）
      return !oid && st > 0 && st < 90
    },
    /**
     * 操作列：已挂主单号时的「取消采购」
     * 改动目的：抖店已取消/采购退款完结后隐藏；时间：2026-08-19
     */
    canShowCancelPurchasePaid(item) {
      if (!item?.pdd_order || item.delete_time) return false
      if (this.isDdOrderClosedForCancelPurchase(item)) return false
      if (this.isPurchaseTerminal(item)) return false
      const oid = String(item.pdd_order.order_id || '').trim()
      if (!oid) return false
      const st = Number(item.pdd_order.status || 0)
      // 已发货(130+)/申请退款(140)不可整单取消
      return st > 90 && st < 130
    },
    /** 单组取消：未付/已付未发可取消；已发货/已取消/退款中不可；时间：2026-08-19 */
    canCancelPurchaseGroup(item, group) {
      if (!item || !group) return false
      if (this.isDdOrderClosedForCancelPurchase(item)) return false
      if (this.isPurchaseTerminal(item)) return false
      if (Number(item.combo_type) !== 2 && !(item.alibaba_items && item.alibaba_items.length >= 2)) return false
      const oid = String(group.alibaba_order_id || '').trim()
      if (!oid) return false
      const aliStatus = String(group.alibaba_status || '').toLowerCase()
      // 已发货 / 已取消终态不可再取消
      if (['waitbuyerreceive', 'confirm_goods', 'success', 'cancel', 'terminated'].includes(aliStatus)) return false
      const refundStatus = String(group.refund_status || '').toLowerCase()
      if (['waitselleragree', 'waitbuyermodify', 'waitbuyersend', 'waitsellerreceive', 'refundsuccess'].includes(refundStatus)) {
        return false
      }
      const lines = Array.isArray(group.lines) ? group.lines : []
      if (!lines.length) return false
      // 组内已有上游发货/主运单 → 不可单组取消
      if (lines.some((l) => [40, 50].includes(Number(l.line_status || 0)))) return false
      // 整组已取消/失败：不再显示取消
      if (lines.every((l) => [90, 100].includes(Number(l.line_status || 0)))) return false
      // 仅待采/下单中/待付/待发可取消
      return lines.every((l) => {
        const st = Number(l.line_status || 0)
        return [0, 10, 20, 30].includes(st)
      })
    },
    hasPurchaseGroupAmount(group) {
      if (!group) return false
      return Number(group.pdd_pay_amount || 0) > 0 || Number(group.shipping_fee || 0) > 0 || Number(group.total_amount || 0) > 0
    },
    /** 货品信息：跨卖家多主单时采购价/代发费取各组之和；时间：2026-08-19 */
    getGoodsPurchaseCost(item) {
      const groups = this.getPurchaseGroups(item) || []
      const withAmt = groups.filter((g) => Number(g.pdd_pay_amount || 0) > 0 || Number(g.shipping_fee || 0) > 0)
      if (withAmt.length >= 2) {
        const pay = withAmt.reduce((s, g) => s + Number(g.pdd_pay_amount || 0), 0)
        const ship = withAmt.reduce((s, g) => s + Number(g.shipping_fee || 0), 0)
        return { pay: this.formatMoney(pay), freight: this.formatMoney(ship) }
      }
      return {
        pay: item.pdd_order?.pdd_pay_amount ?? '0.00',
        freight: item.pdd_order?.freight ?? item.pdd_order?.shipping_fee ?? '0.00',
      }
    },
    formatMoney(val) {
      const n = Number(val)
      if (!Number.isFinite(n)) return '0.00'
      return n.toFixed(2)
    },
    delPurchaseGroup(row, group) {
      const oid = String(group?.alibaba_order_id || '').trim()
      if (!oid) {
        this.$message({ type: 'error', message: '缺少采购单号' })
        return
      }
      const aliStatus = String(group?.alibaba_status || '').toLowerCase()
      const tip = aliStatus === 'waitsellersend'
          ? '确认取消该卖家组采购？将申请1688退款，其它组不受影响。'
          : '确认取消该卖家组采购？（其它组不受影响）'
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opOrderManageDelPddOrder({
          data: { ids: row.id, alibaba_order_id: oid },
          success: (res) => {
            if (res.code == 200) {
              this.$message({ type: 'success', message: res.msg })
              this.refresh()
            } else {
              this.$message({ type: 'error', message: res.msg })
            }
          }
        })
      }).catch(() => {})
    },
    needSyncOrder(row) {
      this.$confirm('确认同步采购操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        this.opOrderManageNeedSyncPddOrder({
          data: {ids: row.id},
          success: (res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          }
        })
      }).catch((res) => {
        console.log(res)
      });
    },
    fetchAlibabaSendTime(row) {
      if (!row?.order_alibaba_order?.can_fetch_send_time) {
        return
      }
      this.opOrderManageFetchAlibabaSendTime({
        data: { id: row.id },
        success: (res) => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.msg || '获取成功'
            })
            if (row.order_alibaba_order && res.data) {
              row.order_alibaba_order.send_time = res.data.send_time || 0
              row.order_alibaba_order.send_time_str = res.data.send_time_str || ''
              row.order_alibaba_order.can_fetch_send_time = 0
              row.order_alibaba_order.show_send_time_row = 1
            } else {
              this.refresh()
            }
          } else {
            this.$message({
              type: 'error',
              message: res.msg || '获取失败'
            })
          }
        },
        fail: () => {
          this.$message({
            type: 'error',
            message: '获取失败'
          })
        }
      })
    },
    afterSales(row) {
      this.$confirm('确认同步抖店操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        this.opOrderManageUpdateOrderAfterSale({
          data: {ids: row.id},
          success: (res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          }
        })
      }).catch((res) => {
        console.log(res)
      });
    },
    repealPurchase(row) {
      this.$confirm('确认重新采购操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        this.opOrderManageRepealPurchase({
          data: {ids: row.id},
          success: (res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          }
        })
      }).catch((res) => {
        console.log(res)
      });

    },
    refreshReturnAddress(row) {
      this.$confirm('确定重新获取地址吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        this.opRefreshReturnAddress({
          data: {ids: row.id},
          success: (res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          }
        })
      }).catch((res) => {
        console.log(res)
      });
    },
    editAddress(row) {
      this.$refs.modifyReturnAddress.open(
          '修改退货地址',
          row,
          this.opSetPddReturnAddress,
          (row) => {
            const map = [
              'id', 'name', 'phone', 'province_name',
              'city_name', 'town_name', 'street_name', 'detail',
            ]
            const detail = {};
            for (let key of map) {
              detail[key] = row[key]
            }
            return detail;
          },
          () => {
            this.refresh();
          }
      )
    },
    editAlibabaAddress(row, group) {
      const alibabaOrderId = String(group?.alibaba_order_id || '').trim()
      this.$refs.orderReturnAddress.open(
          '退换货地址',
          row.dd_order_id,
          () => {
            this.refresh();
          },
          {
            alibaba_order_id: alibabaOrderId,
            readonly: Number(row.return_address_readonly) === 1,
          }
      )
    },
    openSyncDdOrderQueue() {
      this.dialog.syncDdOrderQueueDialog = true
      console.log(222,this.dialog.syncDdOrderQueueDialog)
    },
    editProductCode(row, index) {
      let pdd_sku_id = ''
      this.$refs.modifyConfirm.open(
          '商品编码',
          row.pdd_sku_id ?? row.pdd_code,
          this.opUpdateOrderProduct,
          (val) => {
            pdd_sku_id = val
            return {
              pdd_sku_id: val,
              id: row.id
            }
          },
          (res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              // this.refresh(true)
              this.list[index].pdd_sku_id = pdd_sku_id
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          }
      )
    },
    editPddAccount(row) {
      this.$refs.modifyConfirm.open(
          '采购账号',
          row.pdd_order.account,
          this.opUpdatePddAccount,
          (val) => {
            return {
              account: val,
              ids: row.id
            }
          },
          (res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          }
      )
    },
    editPddOrderNo(row) {
      this.$refs.modifyConfirmOrderNo.open(
          '设置采购单号',
          {order_no: row.pdd_order?.order_id, account: row.pdd_order?.account},
          this.opUpdatePddOrderNo,
          (val) => {
            return {
              pdd_order_no: val.pdd_order_no,
              pdd_account_id: val.pdd_account_id,
              ids: row.id
            }
          },
          (res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          }
      )
    },
    editBuyMode(row) {
      this.$confirm('确定切换采购模式吗? 切换后请重新启动任务', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opUpdateBuyMode({
          data: {ids: row.id}, success: (res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          }
        })
      }).catch(() => {
      });
    },
    toDoOrderPay(row) {
      this.$confirm('确定支付该采购订单吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opDoOrderPay({
          data: {ids: row.id}, success: (res) => {
            if (res.code == 200) {
              if (res.data && res.data.pay_url) {
                window.open(res.data.pay_url, '_blank')
                this.$message({
                  type: 'success',
                  message: res.msg || '请在新窗口完成1688支付'
                })
              } else {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              }
              this.refresh()
            } else {
              if (res.msg == '支付失败未签约或未绑定') {
                this.showOpenPay()
              }else{
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }

            }
          }
        })
      }).catch(() => {
      });
    },
    editSellerWords(row) {
      this.$refs.modifyConfirm.open(
          '商家留言',
          row.order.seller_words,
          this.opSetSellerWords,
          (val) => {
            return {
              seller_words: val,
              order_id: row.order_id
            }
          },
          (res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          },
          'textarea'
      )
    },
    openImg(row) {
      console.log(row)
      let htm = '<img style="object-fit: cover;margin-right: 10px;max-height:70vh;" src="' + row.product_pic + '" alt="">'
      htm += '<div style="margin-top:10px;font-size:16px;">' + row.spec_value + '</div>';
      htm += '<div style="margin-top:5px;font-size:16px;">实付:￥' + row.pay_amount + '</div>';
      this.$alert(htm, row.product_name, {
        dangerouslyUseHTMLString: true,
        showClose: false,
        confirmButtonText: '关闭',
        closeOnClickModal: true,
        customClass: 'zdy-message-box'
      });
    },
    showOriginalOrder(dd_order_id, type = 1) {
      console.log(dd_order_id.substring(0, dd_order_id.length - 1));
      if (type === 2) {
        this.searchData.dd_order_id = dd_order_id;
      } else {
        this.searchData.dd_order_id = dd_order_id.substring(0, dd_order_id.length - 1);
      }
      this.refresh();
    },
    showOpenPay(){
      let html = `<div>
					<p style="font-weight: bold;font-size: 14px;">开启后，免密订单笔数无限制，采购更快捷</p>
					<p style="font-size: 12px;">1、请使用当前登录的1688账号绑定支付宝；</p>
					<p style="font-size: 12px;">2、且务必宝石支付宝余额充足，余额不足将不能支付；</p>
					<p style="font-size: 12px;">3、单笔支付限额500元/笔;支付笔数不限。</p>
				</div>`
      this.$alert(html, '请先开通支付宝免密支付', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '去开通',
        cancelButtonText: '暂不开通',
        closeOnClickModal: true,
        closeOnPressEscape: true,
        showClose: false,
        showCancelButton: true,
        customClass: 'zdy-message-box'
      }).then(() => {
        window.open('https://tradeconfig.1688.com/foundation/withhold_manage.htm')
      })
    },
    setChange(val) {
      // if(this.$store.state.login.user_level == 9 && this.searchData.group_ids) {
      //   this.searchData.group_ids = []
      //   this.$message.error('普通会员无法使用分组');
      //   return
      // }
    },
  }
}
</script>

<style scoped>
.flex{
  display: flex
}

.center {
  display: flex;
  flex: 1;
}

.goods_main {
  padding: 36px 40px 46px;
  min-height: 70vh;
}

.select_wrap {
  margin-top: 24px;
  display: flex;
  flex-wrap: wrap;
}

.select_wrap .mr {
  margin-right: 15px;
}

.select_wrap .w290 {
  width: 220px;
  /*	margin-top: 14px;
    margin-right: 15px;*/
}
.select_wrap .w320{
  width: 320px;
}


.select_wrap .label_title {
  width: 96px;
  height: 100%;
  font-size: 12px;
  color: #999;
  display: flex;
  align-items: center;
  padding-left: 6px;
}

.select_wrap .label_title .icon-shuoming {
  font-size: 12px;
  color: #999;
  margin-left: 2px;
}

.select_wrap .search-amount-range {
  display: flex;
  align-items: center;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
  height: 34px;
  overflow: hidden;
}

.select_wrap .search-amount-range:focus-within {
  border-color: var(--red);
}

:deep(.select_wrap .search-amount-range .amount-input .el-input__inner){
  border: none;
  box-shadow: none;
  text-align: center;
}

.select_wrap .search-amount-range .amount-sep {
  color: #999;
  font-size: 12px;
  padding: 0 2px;
  flex-shrink: 0;
  line-height: 1;
}

.tabs_wrap {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
}

.tabs_wrap .tab {
  height: 100%;
  padding: 30px 5px 0;
  position: relative;
  line-height: 1;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tabs_wrap .tab .mark {
  position: absolute;
  vertical-align: middle;
  display: inline-block;
  right: -10px;
  bottom: 10px;
}

.tabs_wrap .tab.active {
  font-weight: bold;
  color: var(--red);
}

.tabs_wrap .tab.active::after {
  content: '';
  width: 100%;
  height: 3px;
  background: var(--red);
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 2;
}

.tabs_wrap .tab .iconfont {
  font-size: 14px;
  color: #1966ff;
  margin-left: 4px;
}

.totals_btn {
  margin-top: 14px;
  display: flex;
  align-items: center;
}

.totals_btn .totals {
  font-size: 12px;
  color: #333;
  padding-right: 16px;
  margin-right: 16px;
  line-height: 1;
  border-right: 1px solid #ccc;
}

.total_profit {
  margin-left: 10px;
  font-size: 14px;
}

.totals_btn .decrypt_msg {
  font-size: 14px;
  color: var(--red);
  padding-left: 10px;
}

.totals_btn .damaged_total_summary {
  margin-left: auto;
  font-size: 14px;
  color: #333;
  white-space: nowrap;
}

.totals_btn .damaged_total_summary span {
  color: #f56c6c;
  font-weight: 600;
  margin-left: 4px;
}

.list_title {
  /*width: 100%;*/
  height: 50px;
  background: #f9f9f9;
  margin-top: 10px;
  padding: 0 20px;
  display: grid;
  /*grid-template-columns: 50px 1fr 100px 180px 150px 150px 240px 150px;*/
  grid-template-columns: 2.6vw 1fr 5.2vw 9.3vw 7.8vw 7.8vw 12.5vw 7.8vw;
  grid-gap: 20px;
  align-items: center;
  font-size: 12px;
  color: #666;
  line-height: 1;
}


.list_title .t6 {
/*  margin: 0 12px 0 0;
  width: 240px;*/
  text-align: left;
  display: flex;
  align-items: center;
}

.list_title .t6 .purchase_col_tip {
  margin-left: 4px;
  font-size: 14px;
  color: #909399;
  cursor: pointer;
}
.list_title .t7{
  text-align: center;
}

.list_title .t8 {
  margin: 0 20px 0 0;
  flex: 1;
  text-align: right;
}

.order_list li {
  margin-top: 10px;
  font-size: 12px;
}

.order_list li .info_top {
  background: #fff6f7;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.order_list li .info_top .order_top_actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding-right: 20px;
  gap: 6px;
}

.order_list li .info_top .order_flag {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 4px;
}

.order_list li .info_top .order_flag .item {
  display: inline-flex;
  flex-shrink: 0;
}

.order_list li .info_top .order_flag .flag_box {
  white-space: nowrap;
  padding: 2px 7px;
  color: #fff;
  background: red;
  border-radius: 3px;
  cursor: pointer;
}

.order_list li .info_top .order_flag .flag_box.old {
  background: #0990c0;
}

.order_list li .info_top .order_flag .flag_box.damaged {
  background: #e6a23c;
  margin-left: 4px;
}

.order_list li .info_top .order_flag .flag_box.damaged .damaged_amount_inline {
  color: #db4242;
  font-weight: 600;
}

.order_list li .order_nums {
  width: 100%;
  height: 40px;
  background: #fff6f7;
  display: flex;
  align-items: center;
  position: relative;
}

.order_list li .order_nums .btn-remark {
  position: absolute;
  right: 20px;
  cursor: pointer;
  font-size: 14px;
}

.order_list li .order_nums .check_box {
  margin-left: 20px;
}

.order_list li .order_nums .num {
  display: flex;
  align-items: center;
  margin-left: 12px;
  color: #666666;
}

.order_list li .order_nums .num .iconfont {
  cursor: pointer;
  font-size: 14px;
  color: #666;
  margin-left: 8px;
}

.order_list li .order_nums .num .baba-order-more {
  margin-left: 8px;
  font-size: 12px;
  color: #409eff;
  line-height: 1;
  text-decoration: none;
}

.order_list li .order_nums .num .baba-order-more:hover {
  color: #66b1ff;
}

.order-id-link {
  cursor: pointer;
}

.baba-order-ids-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.baba-order-ids-list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 4px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  color: #333;
}

.baba-order-ids-list li:last-child {
  border-bottom: none;
}

.baba-order-ids-list .iconfont {
  cursor: pointer;
  margin-left: 12px;
  color: #666;
  font-size: 14px;
}

.order_list li .order_nums .date {
  margin-left: 26px;
  color: #666666;
}
.order_list li .order_nums .as-countdown {
  margin: 4px 0 0 26px;
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  cursor: pointer;
}
.order_list li .order_nums .as-countdown:hover {
  opacity: 0.85;
}
.order_list li .order_nums .as-countdown-num {
  color: #f0413e;
  font-weight: 600;
}

.order_list li .order_nums .abnormal_btn {
  margin-left: auto;
  margin-right: 20px;
}

.order_list li .order_nums .maoli {
  margin-left: 30px;
  color: #666666;
}

.order_list li .order_info {
  padding: 20px;
  border-bottom: 1px dashed #eee;
  display: grid;
  /* grid-template-columns: 1fr 150px 150px 240px 150px;*/
  grid-template-columns: 1fr 7.8vw 7.8vw 12.5vw 7.8vw;
  grid-gap: 20px;
  align-items: flex-start;
  line-height: 1;
}

.order_list li .order_info .order_product {
  display: flex;
  flex-direction: column;
}

.order_list li .order_info .order_product .product_item {
  display: grid;
  /*grid-template-columns: 1fr 100px 180px;*/
  grid-template-columns: 1fr 5.2vw 9.3vw;
  grid-gap: 20px;
  padding-bottom: 20px;
}

.order_list li .order_info .order_product .product_item:last-child {
  padding-bottom: 0;
}

.order_list li .order_info .goods_info {
  display: flex;
  /*width: 242px;
  margin-left: 20px;*/
}

.order_list li .order_info .goods_info .img_box {
  width: 48px;
  height: 48px;
  background-color: #eeeeee;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
}

.order_list li .order_info .goods_info .con_box {
  flex: 1;
  width: 0;
  margin-left: 10px;
}

.order_list li .order_info .goods_info .con_box .title {
  line-height: 16px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.order_list li .order_info .goods_info .con_box .t1 {
  color: #999999;
  margin-top: 12px;
  line-height: 14px;
}

.order_list li .order_info .goods_info .con_box .t2 {
  color: #999999;
  margin-top: 8px;
}

.order_list li .order_info .goods_info .con_box .t2 .sp_remark {
  display: inline-block;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #f0b92c;
}

.order_list li .order_info .goods_info .con_box .stock_msg {
  color: var(--red);
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
}
.order_list li .order_info .goods_info .con_box .stock_msg span{
  flex: 1;
}
.order_list li .order_info .goods_info .con_box .guanlian {
  color: #1966ff;
  margin-top: 8px;
  cursor: pointer;
}

.order_list li .order_info .goods_info .con_box .guanlian:hover {
  text-decoration: underline;
}

/*.order_list li .order_info .goods_num {
	margin: 0 20px;
	width: 60px;
	text-align: right;
}*/

.order_list li .order_info .goods_num .t1 {
  color: #333333;
}

.order_list li .order_info .goods_num .t2 {
  color: #999999;
  margin-top: 10px;
}

/*.order_list li .order_info .goods_sales {
	margin: 0 10px;
	width: 140px;
	text-align: left;
}*/

.order_list li .order_info .goods_sales > p {
  line-height: 18px;
  color: #333;
}

.order_list li .order_info .goods_sales > p.red {
  color: var(--red);
  cursor: pointer;
}

/*.order_list li .order_info .goods_pay {
	margin-left: 20px;
	width: 100px;
	text-align: right;
}*/

.order_list li .order_info .goods_pay .t1 {
  color: #333333;
}

.order_list li .order_info .goods_pay .t2 {
  color: #333333;
  margin-top: 10px;
}

.order_list li .order_info .goods_pay .t3 {
  color: #666666;
  margin-top: 20px;
}

.order_list li .order_info .goods_pay .t4 {
  color: #666666;
  margin-top: 10px;
}

/*.order_list li .order_info .goods_buyer {
	margin: 0 20px;
	width: 130px;
	text-align: left;
}*/

.order_list li .order_info .goods_buyer .t1 {
  color: #333333;
}

.order_list li .order_info .goods_buyer .t2 {
  color: #333333;
  margin-top: 10px;
}

.order_list li .order_info .goods_buyer .t2 .return_address{
  cursor: pointer;
  color: #666;
}
.order_list li .order_info .goods_buyer .t2 .return_address.exist{
  cursor: pointer;
  color: #00aa00;
}
.order_list li .order_info .goods_buyer .t2 .return_address:hover{
  text-decoration: underline;
}
.order_list li .order_info .goods_buyer .t3 {
  color: #666666;
  margin-top: 20px;
}

.order_list li .order_info .goods_buyer .t4 {
  color: #666666;
  margin-top: 10px;
}

.order_list li .order_info .goods_buyer > p {
  line-height: 18px;
  color: #666;
}

.order_list li .order_info .goods_buyer > p .iconfont {
  cursor: pointer;
  font-size: 12px;
  color: #666;
  margin-left: 8px;
}

.order_list li .order_info .goods_purchase_detail {
  margin: 0 12px 0 0;
  width: 240px;
  flex-shrink: 0;
  text-align: left;
  line-height: 1.4;
}
.order_list li .order_info .goods_purchase_detail .purchase_order_block {
  margin-bottom: 10px;
  padding: 8px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
}
.order_list li .order_info .goods_purchase_detail .purchase_order_block:last-of-type {
  margin-bottom: 8px;
}
.order_list li .order_info .goods_purchase_detail .purchase_order_block.is-fail {
  background: #fff7f7;
  border-color: #ffccc7;
}
.order_list li .order_info .goods_purchase_detail .purchase_order_head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}
.order_list li .order_info .goods_purchase_detail .po_label {
  font-weight: 600;
  color: #333;
}
.order_list li .order_info .goods_purchase_detail .po_order_id {
  font-size: 12px;
  color: #666;
  word-break: break-all;
}
.order_list li .order_info .goods_purchase_detail .po_order_id.muted {
  color: #bbb;
}
.order_list li .order_info .goods_purchase_detail .purchase_order_meta {
  margin-top: 4px;
  font-size: 12px;
  color: #666;
  line-height: 1.5;
}
.order_list li .order_info .goods_purchase_detail .purchase_order_meta p {
  margin: 0;
}
.order_list li .order_info .goods_purchase_detail .purchase_order_meta .po_fee {
  margin-left: 10px;
}
.order_list li .order_info .goods_purchase_detail .purchase_account_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 2px;
}
.order_list li .order_info .goods_purchase_detail .purchase_account_row .account_text {
  flex: 1;
  min-width: 0;
  word-break: break-all;
}
.order_list li .order_info .goods_purchase_detail .purchase_account_row .cancel_group_btn {
  flex-shrink: 0;
  padding: 4px 8px;
}

.order_list li .order_info .goods_purchase_detail .purchase_supplier {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  color: #333;
  font-size: 12px;
  margin-bottom: 10px;
}
.order_list li .order_info .goods_purchase_detail .line_status_tag .label {
  color: #666;
  margin-right: 4px;
}
.order_list li .order_info .goods_purchase_detail .purchase_supplier .label {
  color: #666;
  margin-right: 4px;
}

.order_list li .order_info .goods_purchase_detail .purchase_supplier .name {
  color: #333;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.order_list li .order_info .goods_purchase_detail .purchase_supplier .purchase_icon {
  margin-left: 6px;
  font-size: 14px;
  color: #1966ff;
  cursor: pointer;
}

.order_list li .order_info .goods_purchase_detail .purchase_product_card {
  display: flex;
  padding: 8px;
  background: #fafafa;
  border: 1px solid #eee;
  border-radius: 6px;
  margin-bottom: 2px;
}

.order_list li .order_info .goods_purchase_detail .purchase_product_card .card_img {
  width: 44px;
  height: 44px;
  border-radius: 4px;
  overflow: hidden;
  background: #eee;
  flex-shrink: 0;
}

.order_list li .order_info .goods_purchase_detail .purchase_product_card .card_img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.order_list li .order_info .goods_purchase_detail .purchase_product_card .card_body {
  flex: 1;
  width: 0;
  margin-left: 8px;
}

.order_list li .order_info .goods_purchase_detail .purchase_product_card .card_title {
  font-size: 12px;
  color: #333;
  line-height: 16px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.order_list li .order_info .goods_purchase_detail .purchase_product_card .card_img.is-link {
  cursor: pointer;
}

.order_list li .order_info .goods_purchase_detail .purchase_product_card .card_title.is-link {
  cursor: pointer;
}

.order_list li .order_info .goods_purchase_detail .purchase_product_card .card_sku,
.order_list li .order_info .goods_purchase_detail .purchase_product_card .card_min {
  margin-top: 6px;
  font-size: 12px;
  color: #999;
  line-height: 14px;
}
.order_list li .order_info .goods_purchase_detail .combo_item_card {
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #f0f0f0;
}
.order_list li .order_info .goods_purchase_detail .combo_item_card:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.order_list li .order_info .goods_purchase_detail .combo_item_card.is-fail {
  background: #fff7f7;
}
.order_list li .order_info .goods_purchase_detail .card_title_row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin: 0;
}
.order_list li .order_info .goods_purchase_detail .combo_line_idx {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff1f0;
  color: #cf1322;
  font-size: 11px;
  line-height: 16px;
  text-align: center;
}
.order_list li .order_info .goods_purchase_detail .line_status_tag {
  font-size: 11px;
  border-radius: 2px;
  background: #f5f5f5;
  color: #666;
}
.order_list li .order_info .goods_purchase_detail .line_status_tag.st-90,
.order_list li .order_info .goods_purchase_detail .line_status_tag.st-100 {
  background: #fff1f0;
  color: #cf1322;
}
.order_list li .order_info .goods_purchase_detail .line_status_tag.st-30,
.order_list li .order_info .goods_purchase_detail .line_status_tag.st-40,
.order_list li .order_info .goods_purchase_detail .line_status_tag.st-50 {
  background: #f6ffed;
  color: #389e0d;
}
.order_list li .order_info .goods_purchase_detail .frozen_tag {
  font-size: 11px;
  color: #d46b08;
  background: #fff7e6;
  padding: 0 4px;
  border-radius: 2px;
}
.order_list li .order_info .goods_purchase_detail .card_fail_msg {
  margin: 2px 0 0;
  font-size: 12px;
  color: #cf1322;
  line-height: 1.4;
}
.order_list li .order_info .goods_sales .combo_flag {
  display: inline-block;
  padding: 0 6px;
  font-size: 12px;
  color: #cf1322;
  background: #fff1f0;
  border: 1px solid #ffa39e;
  border-radius: 2px;
}
.order_list li .order_info .goods_sales .red {
  color: #cf1322;
}

.order_list li .order_info .goods_purchase_detail .purchase_footer {
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 8px;
}

.order_list li .order_info .goods_purchase_detail .purchase_footer.is_linked {
  justify-content: space-between;
}

.order_list li .order_info .goods_purchase_detail .purchase_footer .return_address_row {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2px 6px;
  background: #f7f8fa;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;
}

.order_list li .order_info .goods_purchase_detail .purchase_footer .return_address_row:hover {
  background: #eef3ff;
  border-color: #c9daff;
}

.order_list li .order_info .goods_purchase_detail .purchase_footer .return_address_head {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 4px;
  width: 100%;
  min-width: 0;
  line-height: 16px;
}

.order_list li .order_info .goods_purchase_detail .purchase_footer .return_label {
  color: #666;
  font-size: 12px;
  flex-shrink: 0;
  line-height: 16px;
}

.order_list li .order_info .goods_purchase_detail .purchase_footer .return_status_tag {
  display: inline-block;
  padding: 0 4px;
  font-size: 11px;
  line-height: 16px;
  border-radius: 2px;
  flex-shrink: 0;
}

.order_list li .order_info .goods_purchase_detail .purchase_footer .return_address_row.is-success .return_status_tag {
  color: #389e0d;
  background: #f6ffed;
}

.order_list li .order_info .goods_purchase_detail .purchase_footer .return_address_row.is-processing .return_status_tag {
  color: #1966ff;
  background: #eef3ff;
}

.order_list li .order_info .goods_purchase_detail .purchase_footer .return_address_row.is-pending .return_status_tag {
  color: #d46b08;
  background: #fff7e6;
}

.order_list li .order_info .goods_purchase_detail .purchase_footer .return_address_row.is-error .return_status_tag {
  color: #cf1322;
  background: #fff1f0;
}

.order_list li .order_info .goods_purchase_detail .purchase_footer .return_edit_icon {
  margin-left: auto;
  font-size: 12px;
  color: #999;
  flex-shrink: 0;
  line-height: 1;
}

.order_list li .order_info .goods_purchase_detail .purchase_footer .return_address_row:hover .return_edit_icon {
  color: #1966ff;
}

.order_list li .order_info .goods_purchase_detail .purchase_footer .return_warn_icon {
  font-size: 12px;
  color: #ff4d4f;
  flex-shrink: 0;
  line-height: 1;
}

.order_list li .order_info .goods_purchase_detail .purchase_footer .return_time {
  margin: 0;
  font-size: 10px;
  color: #999;
  line-height: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.order_list li .order_info .goods_purchase_detail .purchase_footer .modify_link_btn {
  padding: 0 8px;
  height: auto !important;
  font-size: 12px;
  flex-shrink: 0;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.order_list li .order_info .goods_purchase_detail .purchase_empty {
  font-size: 12px;
  color: #999;
  text-align: center;
  padding: 8px 0;
}

.order_list li .order_info .goods_status {
  text-align: center;
}

/*.order_list li .order_info .goods_status:last-child {
  text-align: right;
}*/

.order_list li .order_info .goods_status > p {
  margin-bottom: 10px;
}

.order_list li .order_info .goods_status .details {
  color: #f0413e;
  cursor: pointer;
}

.order_list li .order_info .goods_status .details:hover {
  text-decoration: underline;
}

.order_list li .order_info .goods_status p > a {
  color: #f0413e;
  cursor: pointer;
}

.order_list li .order_info .goods_status p > a:hover {
  text-decoration: underline;
}

.order_list li .order_remarks {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 66px;
}

.order_list li .order_remarks .remarks_item {
  display: flex;
  flex: 1;
}

.order_list li .order_remarks .remarks_item.abnormal {
  width: 100px;
  flex: unset;
  text-align: right;
  color: #f0b92c;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
  font-weight: bold
}

.order_list li .order_remarks .txt {
  font-size: 12px;
  color: #999999;
  line-height: 18px;
  max-width: 110px;
  box-sizing: border-box;
  padding-left: 10px;
}

.order_list li .order_remarks .remarks {
  flex: 1;
  width: 0;
  font-size: 12px;
  color: #333;
  line-height: 18px;
}

.turn_page {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.order_list li .order_remarks .remarks i {
  cursor: pointer;
}

.order_list li .check_box {
  margin-left: 20px;
  height: 48px;
  display: flex;
  align-items: center;
}

:deep(.order_list li .check_box .el-checkbox__label) {
  display: none !important;
}

.order_list .shop_name {
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  margin-right: 5px;
}

.delete-order-confirm__tip {
  margin: 0 0 14px;
  font-size: 14px;
  color: #606266;
  line-height: 1.5;
}

.delete-order-confirm__hint {
  margin: 8px 0 0;
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}
.query_permanent_link {
  color: #409EFF;
  cursor: pointer;
}
.query_permanent_yes {
  margin: 0 0 10px;
  font-size: 16px;
}
.query_permanent_offers {
  margin: 0;
  line-height: 1.8;
  word-break: break-all;
}
.query_permanent_offer_link {
  color: #409EFF;
  cursor: pointer;
  text-decoration: none;
}
.query_permanent_offer_link:hover {
  text-decoration: underline;
}
</style>
<style scoped>
:deep(.has-time .el-button ){
  padding: 7px 15px;
}

:deep(.select_wrap .el-range-editor .el-range-input) {
  font-size: 1em;
}

:deep(.select_wrap .el-input--prefix .el-input__inner) {
  padding-left: 96px !important;
  height: 34px !important;
  line-height: 34px !important;
  font-size: 12px !important;
}

:deep(.el-select .el-input.is-focus .el-input__inner, .el-select .el-input__inner:focus ){
  border-color: var(--red);
}

:deep(.el-select-dropdown__item.selected) {
  color: var(--red);
}

:deep(.select_wrap .el-input--prefix .el-input__inner:focus) {
  border-color: var(--red);
}

:deep(.el-date-editor .el-range-separator) {
  line-height: 26px;
}

:deep(.el-range-editor.is-active, .el-range-editor.is-active:hover ){
  border-color: var(--red);
}

:deep(.el-date-table td.end-date span, .el-date-table td.start-date span) {
  background-color: var(--red);
}

:deep(.el-date-table td.today span ){
  color: var(--red);
}

:deep(.el-picker-panel__icon-btn:hover, .el-date-table td span:hover, .el-date-table td div:hover, .el-date-table td.available:hover, .el-picker-panel__shortcut:hover ){
  color: var(--red);
}

:deep(.el-button ){
  color: #333;
  border-color: #ddd;
}

:deep(.el-button--small) {
  padding: 7px 15px;
}

:deep(.el-checkbox ){
  color: #666;
  display: flex;
  align-items: center;
}

:deep(.el-checkbox__inner ){
  border-color: #ddd;
  width: 16px;
  height: 16px;
}

:deep(.el-checkbox__input ){
  display: flex;
}

:deep(.el-checkbox__label) {
  font-size: 12px;
  line-height: 1;
}

:deep(.el-checkbox__inner::after) {
  height: 9px;
  left: 5px;
}

:deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner::before ){
  height: 4px;
}

/*red border color*/
:deep(.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__inner:hover, .el-checkbox__input.is-focus .el-checkbox__inner, .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus) {
  border-color: var(--red);
}

/*red color*/
:deep(.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked + .el-checkbox__label, .el-pager li.active, .el-pagination button:hover, .el-pager li:hover) {
  color: var(--red);
}

/*red background color*/
:deep(.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  background-color: var(--red);
}

:deep(.el-input__icon) {
  line-height: unset;
}

:deep(.el-button--primary, .el-button--primary:hover) {
  background-color: var(--red) !important;
  border-color: var(--red) !important;
  color: #fff !important;
}

:deep(.el-button:hover) {
  border-color: var(--red) !important;
  background-color: rgba(240, 65, 62, 0.1) !important;
  color: var(--red) !important;
}

:deep(.el-date-editor--datetimerange .el-icon-time) {
  line-height: 28px;
}

:deep(.el-date-editor .el-range-separator) {
  width: 20px;
}

.red {
  color: var(--red) !important;
}
.star {
  font-size: 16px;
}
</style>
